import React, { Component } from "react";
import { API } from "aws-amplify";
import { LinkContainer } from "react-router-bootstrap";

import "react-table/react-table.css";
import "containers/common/Detail.css";

import AddressList from "containers/property/AddressList";
import PropertyIntegrationsList from "containers/property/PropertyIntegrationsList";
import PropertySaleList from "containers/property/PropertySaleList";
import LeaseList from "containers/property/LeaseList";
import OccupancyRateList from "containers/property/OccupancyRateList";
import LeasingAgentList from "containers/property/LeasingAgentList";
import BuildingNameList from "containers/property/BuildingNameList";
import StrataUnitList from "containers/property/StrataUnitList";
import BuildingGradeList from "containers/property/BuildingGradeList";
import LiftOperatorList from "containers/property/LiftOperatorList";
import PropertyOwnerList from "containers/property/PropertyOwnerList";
import QueryList from "containers/property/QueryList";
import NaberList from "containers/property/NaberList";
import PropertyClassificationList from "containers/property/PropertyClassificationList";
import PropertyProposalList from "containers/property/PropertyProposalList";
import PropertySaleSheetList from "containers/property/PropertySaleSheetList";
import PropertyArticleList from "containers/property/PropertyArticleList";
import TitleDetailsList from "containers/property/TitleDetailsList";
import VolumeFoliosList from "containers/property/VolumeFoliosList";
import RefreshButton from "components/RefreshButton";

import AddressModal from "containers/property/AddressModal";
import PropertyIntegrationsModal from "containers/property/PropertyIntegrationsModal";
import TitleDetailsModal from "containers/property/TitleDetailsModal";
import VolumeFoliosModal from "containers/property/VolumeFoliosModal";
import WithholdingsModal from "containers/property/WithholdingsModal";
import PropertyAddModal from "containers/property/PropertyAddModal";
import BuildingGradeModal from "containers/property/BuildingGradeModal";
import BuildingNameModal from "containers/property/BuildingNameModal";
import PropertyClassificationModal from "containers/property/PropertyClassificationModal";
import OwnerSearchModal from "containers/owner/OwnerSearchModal";
import { s3GetURL } from "lib/awsLib";
import { Form, Row, Col, Card, InputGroup, Tabs, Tab, Button, Alert, Nav, Modal, NavDropdown } from "react-bootstrap";
import { s3GetFolderFiles } from "lib/awsLib";

import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { css } from "@emotion/core";
import { PacmanLoader } from "react-spinners";
import Moment from "moment";

export default class PropertyDetail extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false; //this is to deal with the component unmounting but state trying to be updated. At the time Amplify is not supporting the axios cancel
    this.updateTableState = this.updateTableState.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.saveAddressesRecord = this.saveAddressesRecord.bind(this);
    
    this.getTitleDetails = this.getTitleDetails.bind(this);
    this.getVolumeFolios = this.getVolumeFolios.bind(this);

    this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
    this.getAgentsLeasing = this.getAgentsLeasing.bind(this);
    this.getLeasingAgentContacts = this.getLeasingAgentContacts.bind(this);

    this.updateIntegrations = this.updateIntegrations.bind(this);
    this.acceptIntegration = this.acceptIntegration.bind(this);
    this.rejectIntegration = this.rejectIntegration.bind(this);
    this.getIntegrations = this.getIntegrations.bind(this);

    this.state = {
      addressSaved: false,
      isLoading: null,
      isDeleting: null,
      modified: false,
      property: null,
      addressFilter: null,
      integrationFilter: null,
      articleFilter: null,
      buildingGradeFilter: null,
      buildingNameFilter: null,
      strataUnitFilter: null,
      suburbFilter: null,
      leaseFilter: null,
      liftOperatorFilter: null,
      naberFilter: null,
      proposalFilter: null,
      propertyClassificationFilter: null,
      propertyOwnerFilter: null,
      occupancyFilter: null,
      queryFilter: null,
      saleFilter: null,
      saleSheetFilter: null,
      disableSubDividedUnit: true,
      showAlert: false,
      errorMessage: "",
      tabKey: 0,
      tab: "property",
      idList: [],
      previousId: null,
      nextId: null,
      currentIdIndex: null,

      showWanring: false,
      agentMenuIsOpen: false,

      copyPropertyOwner: "",
      copyPropertyOwnerAndDeleteFlag: false,
      warningMessage: "",
      reloadPage: false,
      selectedClassification: null,
      classificationOptions: [],
      leaseClassificationOptions: [],
      liftOperatorOptions: [],
      buildingGradeSourceOptions: [],
      buildingGradeOptions: [],
      nabersRatingTypeOptions: [
        { value: "Whole building", label: "Whole building" },
        { value: "Base building", label: "Base building" },
      ],
      nabersRatingValues: [],
      addresses: [],
      integrations: [],
      propertyArticles: [],
      withholdings: [],
      titleDetails: [],
      volumeFolios: [],
      buildingGrades: [],
      buildingNames: [],
      strataUnits: [],
      headOffices: [],
      leases: [],
      leaseReviews: [],
      leasingAgents: [],
      liftOperators: [],
      nabers: [],
      occupancyRates: [],
      propertyClassifications: [],
      propertyOwners: [],
      propertySearchOwners: [],
      propertyProposals: [],
      queries: [],
      activeQueries: [],
      propertySales: [],
      propertySaleSheets: [],
      activePropertySaleSheets: [],
      streetOptions: [],
      floorTypeOptions: [
        { value: "Full", label: "Full" },
        { value: "Part", label: "Part" },
      ],
      leasingAgentOptions: [],
      leasingAgentContactOptions: [],
      cityscopeOptions: [],
      suburbOptions: [],
      //  buildingNameOptions: [],
      agentOptions: [],
      agentContactOptions: [],
      properties: [],

      selectedCityscope: null,
      selectedSuburb: null,
      selectedBuildingName: null,
      selectedAgent: null,
      managing_agent_email: null,
      selectedAgentContact: null,
      agentSearch: null,
      agentSearchString: "",
      agentInterstateFlag: false,

      showAgentDialog: false,
      showAddressDialog: false,
      showAddressMatchingDialog: false,
      showTitleDetailsDialog: false,
      showVolumeFoliosDialog: false,
      showWithholdingDialog: false,
      showPropertyAddDialog: false,
      showBuildingNameDialog: false,
      showPropertyClassificationDialog: false,
      showBuildingGradeDialog: false,
      showCityscopeReference: false,
      showAgentDropDown: false,
      showAgentContactDropDown: false,
      showOwnerSearchDialog: false,
      showPropertyOwnerSearchDialog: false,

      //These are used to store original values when user is editing in case they cancel
      orig_cityscope: null,
      orig_map_number: null,
      orig_map_number_suffix: null,
      orig_property_number: null,
      orig_property_number_suffix: null,
      orig_unit_number: null,
      orig_unit_number_suffix: null,
      orig_unit_sort: null,

      property_key: this.props.match.params.id,
      property_id: null,
      origin_db: null,
      cityscope: null,
      map_number: null,
      map_number_suffix: null,
      property_number: null,
      property_number_suffix: null,
      unit_number: null,
      unit_number_suffix: null,
      unit_sort: null,
      parking_yes_no: false,
      suburb: null,
      state: null,
      postcode: null,
      parking_num: null,
      bedrooms: null,
      typical_floor_area: null,
      storeys: null,
      building_area: null,
      year_built: null,
      year_refurb: null,
      site_area: null,
      unit_area: null,
      entity_id_managing_agent: null,
      managing_agent: null,
      description: null,
      historical_listings: null,
      sales_text: null,
      title_details: null,
      title_details_postamble: null,
      title_details_archive: null,
      frontages_text: null,
      zoning_text: null,
      valuations_text: null,
      sales_notes: null,
      description_notes: null,
      owner_notes: null,
      frontages_notes: null,
      occupants_notes: null,
      historical_notes: null,
      title_notes: null,
      valuations_notes: null,
      lift_notes: null,
      occupants_preamble: null,
      occupants_postamble: null,
      owner_preamble: null,
      owner_postamble: null,
      for_sale_line: null,
      nla_date: null,
      lease_term: null,
      description_postamble: null,
      sales_history_postamble: null,
      entity_contact_id_managing_agent: null,
      managing_agent_contact: null,
      internet: null,
      email: null,
      photo_required: false,
      photo_why: null,
      leasing_notes: null,
      title_last_searched: null,
      unit_level_number: null,
      sub_divided_unit: false,
      auto_doors: null,
      head_record_property_id: null,
      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      archived_date: null,
      property_withholding_id: null,
      withholding_text: null,
      withholding_reason_id: null,
      property_withholding_created_date: null,
      property_withholding_created_by: null,
      previous_property_id: null,
      next_property_id: null,

      propertyPhotos: [],
    };
  }

  componentWillReceiveProps(prevProps) {
    console.log("In property componentWillReceiveProps");
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // Clean component and reload?
      console.log("Resetting");
      this.setState(
        {
          property: {},
          // ,property_key: null
          property_id: null,
          disableSubDividedUnit: true,
          origin_db: null,
          cityscope: null,
          // ,idList: []
          properties: [],
          // ,previousId: null
          // ,nextId: null
          currentIdIndex: null,
          map_number: "",
          map_number_suffix: "",
          property_number: "",
          property_number_suffix: "",
          unit_number: "",
          unit_number_suffix: "",
          unit_sort: "",
          parking_yes_no: false,
          suburb: "",
          state: "",
          postcode: "",
          parking_num: "",
          bedrooms: "",
          typical_floor_area: "",
          storeys: "",
          building_area: "",
          year_built: "",
          year_refurb: "",
          site_area: "",
          unit_area: "",
          entity_id_managing_agent: null,
          managing_agent: "",
          description: "",
          historical_listings: "",
          sales_text: "",
          title_details: "",
          title_details_postamble: "",
          title_details_archive: "",
          frontages_text: "",
          zoning_text: "",
          valuations_text: "",
          sales_notes: "",
          description_notes: "",
          owner_notes: "",
          frontages_notes: "",
          occupants_notes: "",
          historical_notes: "",
          title_notes: "",
          valuations_notes: "",
          lift_notes: "",
          occupants_preamble: "",
          occupants_postamble: "",
          owner_preamble: "",
          owner_postamble: "",
          for_sale_line: "",
          nla_date: null,
          lease_term: "",
          description_postamble: "",
          sales_history_postamble: "",
          entity_contact_id_managing_agent: null,
          managing_agent_contact: "",
          internet: "",
          email: "",
          photo_required: false,
          photo_why: null,
          leasing_notes: "",
          title_last_searched: null,
          unit_level_number: null,
          sub_divided_unit: false,
          auto_doors: null,
          created_date: null,
          created_by: "",
          last_edited_date: null,
          last_edited_by: null,
          archived_date: null,
          property_withholding_id: null,
          withholding_text: null,
          withholding_reason_id: null,
          property_withholding_created_date: null,
          property_withholding_created_by: null,
          previous_property_id: null,
          next_property_id: null,
          classificationOptions: [],
          leaseClassificationOptions: [],
          liftOperatorOptions: [],
          buildingGradeSourceOptions: [],
          buildingGradeOptions: [],

          nabersRatingValues: [],
          addresses: [],
          integrations: [],

          propertyArticles: [],
          withholdings: [],
          buildingGrades: [],
          buildingNames: [],
          strataUnits: [],
          headOffices: [],
          leases: [],
          leaseReviews: [],
          leasingAgents: [],
          liftOperators: [],
          nabers: [],
          propertyClassifications: [],
          propertyOwners: [],
          propertyProposals: [],
          queries: [],
          activeQueries: [],
          propertySales: [],
          propertySaleSheets: [],
          activePropertySaleSheets: [],
          streetOptions: [],
          floorTypeOptions: [
            { value: "Full", label: "Full" },
            { value: "Part", label: "Part" },
          ],
          leasingAgentOptions: [],
          leasingAgentContactOptions: [],
          cityscopeOptions: [],
          suburbOptions: [],
          //   ,buildingNameOptions: []
          agentOptions: [],
          agentContactOptions: [],
          properties: [],
          strataUnits: [],
        },
        this.componentDidMount
      );
    }
  }

  componentWillUnmount() {
    console.log("In property componentWillUnmount");

    this._isMounted = false;
    this.setState({
      property: {},
      disableSubDividedUnit: true,
      property_key: null,
      property_id: null,
      origin_db: null,
      cityscope: null,
      // ,idList: []
      properties: [],
      previousId: null,
      nextId: null,
      currentIdIndex: null,
      map_number: null,
      map_number_suffix: null,
      property_number: null,
      property_number_suffix: null,
      unit_number: null,
      unit_number_suffix: null,
      unit_sort: null,
      parking_yes_no: false,
      suburb: null,
      state: null,
      postcode: null,
      parking_num: null,
      bedrooms: null,
      typical_floor_area: null,
      storeys: null,
      building_area: null,
      year_built: null,
      year_refurb: null,
      site_area: null,
      unit_area: null,
      entity_id_managing_agent: null,
      managing_agent: null,
      description: null,
      historical_listings: null,
      sales_text: null,
      title_details: null,
      title_details_postamble: null,
      title_details_archive: null,
      frontages_text: null,
      zoning_text: null,
      valuations_text: null,
      sales_notes: null,
      description_notes: null,
      owner_notes: null,
      frontages_notes: null,
      occupants_notes: null,
      historical_notes: null,
      title_notes: null,
      valuations_notes: null,
      lift_notes: null,
      occupants_preamble: null,
      occupants_postamble: null,
      owner_preamble: null,
      owner_postamble: null,
      for_sale_line: null,
      nla_date: null,
      lease_term: null,
      description_postamble: null,
      sales_history_postamble: null,
      entity_contact_id_managing_agent: null,
      managing_agent_contact: null,
      internet: null,
      email: null,
      photo_required: false,
      photo_why: null,
      leasing_notes: null,
      title_last_searched: null,
      unit_level_number: null,
      sub_divided_unit: false,
      auto_doors: null,
      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      property_withholding_id: null,
      withholding_text: null,
      withholding_reason_id: null,
      property_withholding_created_date: null,
      property_withholding_created_by: null,
      archived_date: null,
      previous_property_id: null,
      next_property_id: null,
      classificationOptions: [],
      leaseClassificationOptions: [],
      liftOperatorOptions: [],
      buildingGradeSourceOptions: [],
      buildingGradeOptions: [],
      nabersRatingTypeOptions: [],
      nabersRatingValues: [],
      addresses: [],
      integrations: [],
      propertyArticles: [],
      withholdings: [],
      buildingGrades: [],
      buildingNames: [],
      strataUnits: [],
      headOffices: [],
      leases: [],
      leaseReviews: [],
      leasingAgents: [],
      liftOperators: [],
      nabers: [],
      propertyClassifications: [],
      propertyOwners: [],
      propertyProposals: [],
      queries: [],
      activeQueries: [],
      propertySales: [],
      propertySaleSheets: [],
      activePropertySaleSheets: [],
      streetOptions: [],
      floorTypeOptions: [
        { value: "Full", label: "Full" },
        { value: "Part", label: "Part" },
      ],
      leasingAgentOptions: [],
      leasingAgentContactOptions: [],
      cityscopeOptions: [],
      suburbOptions: [],
      //  ,buildingNameOptions: []
      agentOptions: [],
      agentContactOptions: [],
      properties: [],
      strataUnits: [],
    });
  }

  async componentDidMount() {
    console.log("In property componentDidMount");
    this._isMounted = true;
    console.log(performance.now());
    try {
      this.setState({ isLoading: true });
      this.generateNabersValues();

      //Lookups
      await this.getCityscopes();

      if (this.props.match.params.id === "new") {
        console.log("New property");
        this.setState({
          showCityscopeReference: true,
        });
        this.setState((state) => ({ created_date: new Date() }));
        this.setState((state) => ({ created_by: this.props.user }));

        await this.syncroniseState();
      } else {
        console.log(this.props.location);

        await this.retrieveProperty();
        await this.retrievePropertyPhotos();
        this.setState((state) => ({
          addressFilter: { propertyid: this.state.property_id },
          integrationFilter: { propertyid: this.state.property_id },
          articleFilter: { propertyid: this.state.property_id, articleid: null },
          buildingGradeFilter: { propertyid: this.state.property_id },
          buildingNameFilter: { propertyid: this.state.property_id },
          strataUnitFilter: { propertyid: this.state.property_key },
          leaseFilter: { propertyid: this.state.property_id, archived: null },
          liftOperatorFilter: { propertyid: this.state.property_id },
          naberFilter: { propertyid: this.state.property_id },
          proposalFilter: { propertyid: this.state.property_id },
          propertyClassificationFilter: { propertyid: this.state.property_id },
          propertyOwnerFilter: { propertyid: this.state.property_id },
          queryFilter: { propertyid: this.state.property_id },
          saleFilter: { propertyid: this.state.property_id },
          saleSheetFilter: { propertyid: this.state.property_id },
          occupancyFilter: { propertyid: this.state.property_id },
          suburbFilter: { cityscope: this.state.cityscope },
        }));

        //If coming from proofing the browse list will be query params not state
        if (this.props.location.search.indexOf("browselist") > 0) {
          const idList = this.props.location.search.replace("?browselist=", "").split(",");
          const currentIdIndex = idList.indexOf(this.props.match.params.id);

          let nextId = null;
          let previousId = null;

          if (currentIdIndex + 1 < idList.length) {
            nextId = idList[currentIdIndex + 1];
          }
          if (currentIdIndex > 0) {
            previousId = idList[currentIdIndex - 1];
          }
          this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex });
        }
        if (this.props.location.state) {
          if (this.props.location.state.hasOwnProperty("data")) {
            const idList = this.props.location.state.data;
            const currentIdIndex = idList.indexOf(this.props.match.params.id);

            let nextId = null;
            let previousId = null;

            if (currentIdIndex + 1 < idList.length) {
              nextId = idList[currentIdIndex + 1];
            }
            if (currentIdIndex > 0) {
              previousId = idList[currentIdIndex - 1];
            }
            this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex });
          }
          //CHeck if tab reference has been provided
          if (this.props.location.state.hasOwnProperty("tab")) {
            this.setState({ tab: this.props.location.state.tab });
            if (this.props.location.state.tab === "sales") {
              this.onTabSelect("8");
            } else if (this.props.location.state.tab === "owners") {
              this.onTabSelect("9");
            } else if (this.props.location.state.tab === "leases") {
              this.onTabSelect("1");
            } else if (this.props.location.state.tab === "property") {
              this.onTabSelect("0");
            }
          } else {
            console.log("In componentDidMount call onTabSelect with index: " + this.state.tabKey);
            this.onTabSelect(this.state.tabKey);
          }
        } else {
          console.log("In componentDidMount call onTabSelect with index: " + this.state.tabKey);
          this.onTabSelect(this.state.tabKey);
        }

        if (this.state.unit_number !== "" && this.state.unit_number !== null) {
          this.setState((state) => ({ disableSubDividedUnit: false }));
        }

        if (this.state.queries.length > 0) {
          var activeQueries = this.state.queries.filter(function (query) {
            return query.active === true;
          });
          this.setState((state) => ({ activeQueries }));
        }

        if (this.state.propertySaleSheets.length > 0) {
          var activePropertySaleSheets = this.state.propertySaleSheets.filter(function (propertySaleSheet) {
            return propertySaleSheet.current === true;
          });
          this.setState((state) => ({ activePropertySaleSheets }));
        }

        if (this.state.propertyArticles.length > 0) {
          let propertyArticles = [...this.state.propertyArticles];
          for (var i = 0; i < propertyArticles.length; i++) {
            const url = await s3GetURL(propertyArticles[i].file_name + "." + propertyArticles[i].file_type, "article");
            if (url) {
              propertyArticles[i].url = url;
            }
          }
          this.setState({ propertyArticles });
        }
      }

      //Get lookups
      this.setState({ selectedCityscope: { value: this.state.cityscope, label: this.state.cityscope } });

      if (this.state.suburb != null) {
        this.setState({ selectedSuburb: { value: this.state.suburb + " (" + this.state.state + ")", label: this.state.suburb + " (" + this.state.state + ")" } });
      }
      this.getSuburbs(this.state.suburbFilter);
      this.getStreets(this.state.suburbFilter);

      this.setState({ selectedAgent: { value: this.state.entity_id_managing_agent, label: this.state.managing_agent } });

      this.setState({ selectedAgentContact: { value: this.state.entity_contact_id_managing_agent, label: this.state.managing_agent_contact } });
      if (this.state.entity_id_managing_agent) {
        this.getAgents({ entityid: this.state.entity_id_managing_agent });
        this.setState((state) => ({ showAgentDropDown: true }));
        this.getAgentContacts({ entityid: this.state.entity_id_managing_agent });
        this.setState((state) => ({ showAgentContactDropDown: true }));
      }

      document.title = this.state.property_key;

      await this.getTitleDetails();
      await this.getVolumeFolios();

      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
    console.log(performance.now());

    if (this.props.location.hash === "#queries") {
      this.onTabSelect(10); // Queries tab
    }
  }

  async syncroniseState() {
    const property = {
      property_key: this.state.property_key,
      property_id: this.state.property_id,
      origin_db: this.state.origin_db,
      cityscope: this.state.cityscope,
      map_number: this.state.map_number,
      map_number_suffix: this.state.map_number_suffix,
      property_number: this.state.property_number,
      property_number_suffix: this.state.property_number_suffix,
      unit_number: this.state.unit_number,
      unit_number_suffix: this.state.unit_number_suffix,
      unit_sort: this.state.unit_sort,
      parking_yes_no: this.state.parking_yes_no,
      suburb: this.state.suburb,
      state: this.state.state,
      postcode: this.state.postcode,
      parking_num: this.state.parking_num,
      bedrooms: this.state.bedrooms,
      typical_floor_area: this.state.typical_floor_area,
      storeys: this.state.storeys,
      building_area: this.state.building_area,
      year_built: this.state.year_built,
      year_refurb: this.state.year_refurb,
      site_area: this.state.site_area,
      unit_area: this.state.unit_area,
      entity_id_managing_agent: this.state.entity_id_managing_agent,
      managing_agent: this.state.managing_agent,
      managing_agent_email: this.state.managing_agent_email,
      description: this.state.description,
      historical_listings: this.state.historical_listings,
      sales_text: this.state.sales_text,
      title_details: this.state.title_details,
      title_details_postamble: this.state.title_details_postamble,
      title_details_archive: this.state.title_details_archive,
      frontages_text: this.state.frontages_text,
      zoning_text: this.state.zoning_text,
      valuations_text: this.state.valuations_text,
      sales_notes: this.state.sales_notes,
      description_notes: this.state.description_notes,
      owner_notes: this.state.owner_notes,
      frontages_notes: this.state.frontages_notes,
      occupants_notes: this.state.occupants_notes,
      historical_notes: this.state.historical_notes,
      title_notes: this.state.title_notes,
      valuations_notes: this.state.valuations_notes,
      lift_notes: this.state.lift_notes,
      occupants_preamble: this.state.occupants_preamble,
      occupants_postamble: this.state.occupants_postamble,
      owner_preamble: this.state.owner_preamble,
      owner_postamble: this.state.owner_postamble,
      for_sale_line: this.state.for_sale_line,
      nla_date: this.state.nla_date,
      lease_term: this.state.lease_term,
      description_postamble: this.state.description_postamble,
      sales_history_postamble: this.state.sales_history_postamble,
      entity_contact_id_managing_agent: this.state.entity_contact_id_managing_agent,
      origin_entity_contact_id_managing_agent: this.state.origin_entity_contact_id_managing_agent,
      internet: this.state.internet,
      email: this.state.email,
      photo_required: this.state.photo_required,
      photo_why: this.state.photo_why,
      leasing_notes: this.state.leasing_notes,
      title_last_searched: this.state.title_last_searched,
      unit_level_number: this.state.unit_level_number,
      sub_divided_unit: this.state.sub_divided_unit,
      auto_doors: this.state.auto_doors,
      head_record_property_id: this.state.head_record_property_id,
      created_date: this.state.created_date,
      created_by: this.state.created_by,
      last_edited_date: this.state.last_edited_date,
      last_edited_by: this.state.last_edited_by,
      archived_date: this.state.archived_date,
      property_withholding_id: this.state.property_withholding_id,
      withholding_text: this.state.withholding_text,
      withholding_reason_id: this.state.withholding_reason_id,
      property_withholding_created_date: this.state.property_withholding_created_date,
      property_withholding_created_by: this.state.property_withholding_created_by,

      previous_property_id: this.state.previous_property_id,
      next_property_id: this.state.next_property_id,
    };

    this.setState({ property });
  }

  async retrieveProperty() {
    const property = await this.getProperty({ user: this.props.user });
    if (this._isMounted) {
      if (Object.entries(property).length > 0) {
        const {
          property_key,
          property_id,
          origin_db,
          cityscope,
          map_number,
          map_number_suffix,
          property_number,
          property_number_suffix,
          unit_number,
          unit_number_suffix,
          unit_sort,
          parking_yes_no,
          suburb,
          state,
          postcode,
          parking_num,
          bedrooms,
          typical_floor_area,
          storeys,
          building_area,
          year_built,
          year_refurb,
          site_area,
          unit_area,
          entity_id_managing_agent,
          managing_agent,
          managing_agent_email,
          description,
          historical_listings,
          sales_text,
          title_details,
          title_details_postamble,
          title_details_archive,
          frontages_text,
          zoning_text,
          valuations_text,
          sales_notes,
          description_notes,
          owner_notes,
          frontages_notes,
          occupants_notes,
          historical_notes,
          title_notes,
          valuations_notes,
          lift_notes,
          occupants_preamble,
          occupants_postamble,
          owner_preamble,
          owner_postamble,
          for_sale_line,
          nla_date,
          lease_term,
          description_postamble,
          sales_history_postamble,
          entity_contact_id_managing_agent,
          managing_agent_contact,
          internet,
          email,
          photo_required,
          photo_why,
          leasing_notes,
          title_last_searched,
          unit_level_number,
          sub_divided_unit,
          auto_doors,
          head_record_property_id,
          created_date,
          created_by,
          last_edited_date,
          last_edited_by,
          archived_date,
          property_withholding_id,
          withholding_text,
          withholding_reason_id,
          property_withholding_created_date,
          property_withholding_created_by,
          previous_property_id,
          next_property_id,
          addresses,
          integrations,
          buildinggrades,
          buildingnames,
          strataunits,
          propertyclassifications,
          queries,
          propertysalesheets,
          propertyowners,
          propertysales,
          propertyarticles,
          propertywithholdings,
        } = property;

        this.setState({
          property,
          property_key,
          property_id,
          origin_db,
          cityscope,
          map_number,
          map_number_suffix,
          property_number,
          property_number_suffix,
          unit_number,
          unit_number_suffix,
          unit_sort,
          parking_yes_no,
          suburb,
          state,
          postcode,
          parking_num,
          bedrooms,
          typical_floor_area,
          storeys,
          building_area,
          year_built,
          year_refurb,
          site_area,
          unit_area,
          entity_id_managing_agent,
          managing_agent,
          managing_agent_email,
          description,
          historical_listings,
          sales_text,
          title_details,
          title_details_postamble,
          title_details_archive,
          frontages_text,
          zoning_text,
          valuations_text,
          sales_notes,
          description_notes,
          owner_notes,
          frontages_notes,
          occupants_notes,
          historical_notes,
          title_notes,
          valuations_notes,
          lift_notes,
          occupants_preamble,
          occupants_postamble,
          owner_preamble,
          owner_postamble,
          for_sale_line,
          nla_date,
          lease_term,
          description_postamble,
          sales_history_postamble,
          entity_contact_id_managing_agent,
          managing_agent_contact,
          internet,
          email,
          photo_required,
          photo_why,
          leasing_notes,
          title_last_searched,
          unit_level_number,
          sub_divided_unit,
          auto_doors,
          head_record_property_id,
          created_date,
          created_by,
          last_edited_date,
          last_edited_by,
          archived_date,
          property_withholding_id,
          withholding_text,
          withholding_reason_id,
          property_withholding_created_date,
          property_withholding_created_by,
          previous_property_id,
          next_property_id,
          addresses: addresses || [],
          integrations: integrations || [],
          buildingGrades: buildinggrades || [],
          buildingNames: buildingnames || [],
          strataUnits: strataunits || [],
          propertyClassifications: propertyclassifications || [],
          queries: queries || [],
          propertySaleSheets: propertysalesheets || [],
          propertyOwners: propertyowners || [],
          propertySales: propertysales || [],
          propertyArticles: propertyarticles || [],
          withholdings: propertywithholdings || [],
        });
      } else {
        let confirmed = window.confirm("The cityscope reference entered does not exist. Do you want to create it?");
        if (confirmed) {
          this.props.history.push("/properties/new", {});
        } else {
          this.props.history.push("/properties");
        }
      }
    }
  }

  async retrievePropertyPhotos() {
    try {
      const basePropertyKey = this.state.property_key.split(".").slice(0, 2).join(".");
      const basePropertyPhotos = await API.get("colin", `/property_photos`, { queryStringParameters: { propertykey: basePropertyKey } });
      const strataUnitPhotos = basePropertyKey !== this.state.property_key ? await API.get("colin", `/property_photos`, { queryStringParameters: { propertykey: this.state.property_key } }) : [];
      const propertyPhotos = await Promise.all(
        [...basePropertyPhotos, ...strataUnitPhotos]
          .filter((p, i, a) => a.findIndex((p2) => p2.file_path === p.file_path) === i) // Only unique images
          .filter((p) => p.file_path.includes("/PropsHTML/")) // Only small images
          .map(async (p) => {
            // Attach the pre-signed URL of the s3 object
            // Need to remove the 'public/' prefix; s3GetURL adds this for us
            const url = p.file_path.split("/").slice(1).join("/");
            const id = p.file_path.split("/").pop().split(".")[0];
            return { ...p, url: await s3GetURL(url), key: id };
          })
      );
      const sortedPhotos = propertyPhotos.sort(this.customSort);
      console.log("propertyPhotos", propertyPhotos);
      console.log("sortedPhotos", sortedPhotos);
      this.setState({ propertyPhotos });
    } catch (e) {
      console.log("Error getting property photos");
      console.error(e);
    }
  }

  customSort = (a, b) => {
    // Extract the numeric part inside the square brackets
    const getNumber = (obj) => {
      const key = obj && obj.key;
      const match = key && key.match(/\[(\d+)\]/);

      if (match) {
        return parseInt(match[1], 10);
      } else {
        // If the regex doesn't match, handle it as needed
        return 0; // or any default value
      }
    };

    // If prefixes are equal, compare the numeric parts
    const numberA = getNumber(a);
    const numberB = getNumber(b);

    return numberA - numberB;
  };

  //Call API
  async getProperty(filter) {
    const response = API.get("colin", `/properties/${this.props.match.params.id}`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getIntegrations() {
    console.log("getIntegrations() called");

    const response = await API.get("colin", `/properties/${this.props.match.params.id}/integrations`);

    await this.setState({ integrations: response });

    console.log("raw response:", response);
  }

  async saveProperty(property, force = false) {
    property.force = force;
    if (this.props.match.params.id === "new" && this.state.property_id === null) {
      const response = API.post("colin", `/properties/new`, { body: property });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    } else {
      const response = API.put("colin", `/properties/${this.state.property_id}`, {
        body: property,
      });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
  }

  async updateStrataBuilingName(strataunitid, strataunit) {
    console.log("updateStrataBuilingName");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/${strataunitid}/buildingname`, { body: strataunit });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataBuilingNameBatch(strataUnitIDs, parameters) {
    console.log("updateStrataBuildingNameBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copybuildingname`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataStreetAddress(strataunitid, strataunit) {
    // console.log("updateStrataBuilingName");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/${strataunitid}/streetaddress`, { body: strataunit });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataStreetAddressBatch(strataUnitIDs, parameters) {
    console.log("updateStrataStreetAddressBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copystreetaddress`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataSuburbBatch(strataUnitIDs, parameters) {
    console.log("updateStrataSuburbBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copysuburb`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataTitleReference(strataunitid, strataunit) {
    // console.log("updateStrataBuilingName");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/${strataunitid}/titledetails`, { body: strataunit });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataTitleReferenceBatch(strataUnitIDs, parameters) {
    console.log("updateStrataTitleReferenceBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copytitlereference`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataPropertySuburb(strataunitid, strataunit) {
    try {
      return API.post("colin", `/properties/${this.state.property_id}/strataunits/${strataunitid}/suburb`, { body: strataunit });
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataPropertySuburbBatch(strataUnitIDs, parameters) {
    console.log("updateStrataPropertySuburbBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copysuburb`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataPropertyClassification(strataunitid, strataunit) {
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/${strataunitid}/propertyclassification`, { body: strataunit });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataPropertyClassificationBatch(strataUnitIDs, parameters) {
    console.log("updateStrataPropertyClassificationBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copyclassification`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataPropertyOwner(strataunitid, strataunit) {
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/${strataunitid}/propertyowner`, { body: strataunit });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async updateStrataPropertyOwnerBatch(strataUnitIDs, parameters) {
    console.log("updateStrataPropertyOwnerBatch");
    const response = API.post("colin", `/properties/${this.state.property_id}/strataunits/copyowner`, { body: {"strataUnitIDs": strataUnitIDs, "parameters": parameters} });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async copyPropertyOwners(propertyOwner) {
    const response = API.post("colin", `/property/${this.state.property_id}/propertyowners/${this.state.copyPropertyOwner}/${this.state.copyPropertyOwnerAndDeleteFlag}`, { body: propertyOwner });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getAgents(filter) {
    try {
      await API.get("colin", `/entities/dropdown`, { queryStringParameters: filter }).then((agentOptions) => {
        if (agentOptions && this._isMounted) {
          this.setState((state) => ({ agentOptions }));
          return agentOptions;
        }
      });
    } catch {
      alert("Error getting agents. Please refresh the page (F5) to try again");
    }
  }

  async getAgentContacts(filter) {
    try {
      await API.get("colin", `/entitycontacts/dropdown`, { queryStringParameters: filter }).then((agentContactOptions) => {
        if (agentContactOptions && this._isMounted) {
          this.setState((state) => ({ agentContactOptions }));
        }
      });
    } catch {
      alert("Error getting agent contacts. Please refresh the page (F5) to try again");
    }
  }

  async getAgentsLeasing(filter) {
    try {
      await API.get("colin", `/entities/dropdown`, { queryStringParameters: filter }).then((leasingAgentOptions) => {
        if (leasingAgentOptions && this._isMounted) {
          this.setState((state) => ({ leasingAgentOptions }));
        }
      });
    } catch {
      alert("Error getting leasing agent options. Please refresh the page (F5) to try again");
    }
  }

  async getLeasingAgentContacts(filter) {
    try {
      await API.get("colin", `/entitycontacts/dropdown`, { queryStringParameters: filter }).then((leasingAgentContactOptions) => {
        if (leasingAgentContactOptions && this._isMounted) {
          this.setState((state) => ({ leasingAgentContactOptions }));
        }
      });
    } catch {
      alert("Error getting leasing agent contacts. Please refresh the page (F5) to try again");
    }
  }

  async getPropertyArticles(filter) {
    try {
      const response = API.get("colin", "/propertyarticles", { queryStringParameters: filter });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    } catch {
      alert("Error getting articles. Please refresh the page (F5) to try again");
    }
  }

  async getStrataUnits(filter) {
    try {
      await API.get("colin", "/properties/" + this.state.property_id + "/strataunits", { queryStringParameters: filter }).then((strataUnits) => {
        if (strataUnits && this._isMounted) {
          this.setState((state) => ({ strataUnits }));
        }
      });
    } catch {
      alert("Error getting strata units. Please refresh the page (F5) to try again");
    }
  }

  async getCityscopes() {
    try {
      await API.get("colin", `/cityscopes/dropdown`).then((cityscopeOptions) => {
        if (cityscopeOptions && this._isMounted) {
          this.setState((state) => ({ cityscopeOptions }));
        }
      });
    } catch {
      alert("Error getting cityscopes. Please refresh the page (F5) to try again");
    }
  }

  async getLeases(filter) {
    try {
      await API.get("colin", "/properties/" + this.state.property_id + "/leases", { queryStringParameters: filter }).then((leases) => {
        if (leases && this._isMounted) {
          this.setState((state) => ({ leases }));
        }
      });
    } catch {
      alert("Error getting leases. Please refresh the page (F5) to try again");
    }
  }

  async getLeasingAgents(filter) {
    try {
      await API.get("colin", "/properties/" + this.state.property_id + "/leasingagents", { queryStringParameters: filter }).then((leasingAgents) => {
        if (leasingAgents && this._isMounted) {
          this.setState((state) => ({ leasingAgents }));
        }
      });
    } catch {
      alert("Error getting leasing agents. Please refresh the page (F5) to try again");
    }
  }

  async getLiftOperators(filter) {
    try {
      await API.get("colin", "/liftoperators", { queryStringParameters: filter }).then((liftOperators) => {
        if (liftOperators && this._isMounted) {
          this.setState((state) => ({ liftOperators }));
        }
      });
    } catch {
      alert("Error getting lift operators. Please refresh the page (F5) to try again");
    }
  }

  async getNabers(filter) {
    try {
      await API.get("colin", "/properties/" + this.state.property_id + "/nabers", { queryStringParameters: filter }).then((nabers) => {
        if (nabers && this._isMounted) {
          this.setState((state) => ({ nabers }));
        }
      });
    } catch {
      alert("Error getting nabers. Please refresh the page (F5) to try again");
    }
  }

  async getOccupancyRates(filter) {
    try {
      await API.get("colin", "/properties/" + this.state.property_id + "/occupancyrates", { queryStringParameters: filter }).then((occupancyRates) => {
        if (occupancyRates && this._isMounted) {
          this.setState((state) => ({ occupancyRates }));
        }
      });
    } catch {
      alert("Error getting Occupancy Rates. Please refresh the page (F5) to try again");
    }
  }

  async getPropertyProposals(filter) {
    try {
      await API.get("colin", "/propertyproposals", { queryStringParameters: filter }).then((propertyProposals) => {
        if (propertyProposals && this._isMounted) {
          this.setState((state) => ({ propertyProposals }));
        }
      });
    } catch {
      alert("Error getting proposals. Please refresh the page (F5) to try again");
    }
  }

  async getPropertyOwners(filter) {
    try {
      return API.get("colin", "/propertyowners", { queryStringParameters: filter });
    } catch {
      alert("Error getting property owners. Please refresh the page (F5) to try again");
    }
  }

  // async getQueries(filter) {
  //     try {
  //         await API.get("colin", "/properties/" + this.state.property_id + "/queries", { 'queryStringParameters': filter}).then((queries) => {
  //             if (queries && this._isMounted) {
  //                 this.setState(state => ({ queries }));
  //                 var activeQueries = queries.filter(function (query) {
  //                     return query.active === true;
  //                 });
  //                 this.setState(state => ({ activeQueries }));
  //             }
  //         });
  //     }
  //     catch{
  //         alert("Error getting queries. Please refresh the page (F5) to try again");
  //     }
  // }

  // async getPropertySalesSheets(filter) {
  //     try {
  //         await API.get("colin", "/propertysalesheets", { 'queryStringParameters': filter}).then((propertySaleSheets) => {

  //             if (propertySaleSheets && this._isMounted) {
  //                 this.setState(state => ({ propertySaleSheets }));
  //                 var activePropertySaleSheets = propertySaleSheets.filter(function (propertySaleSheet) {
  //                     return propertySaleSheet.current === true;
  //                 });
  //                 this.setState(state => ({ activePropertySaleSheets }));

  //             }
  //         });
  //     }
  //     catch{
  //         alert("Error getting sale sheets. Please refresh the page (F5) to try again");
  //     }
  // }
  // async getPropertySales(filter) {
  //     try {
  //         await API.get("colin", `/propertysales`, { 'queryStringParameters': filter}).then((propertySales) => {
  //             if (propertySales && this._isMounted) {
  //                 this.setState(state => ({ propertySales }));
  //             }
  //         });
  //     }
  //     catch{
  //         alert("Error getting sales. Please refresh the page (F5) to try again");
  //     }
  // }

  getSuburbs(filter) {
        try {
      API.get("colin", `/suburbs`, { queryStringParameters: filter }).then((suburbOptions) => {
        if (suburbOptions && this._isMounted) {
          const updatedSuburbs = suburbOptions.map((obj) => {
            obj.label = obj.value;
            return obj;
          });
          this.setState((state) => ({ suburbOptions: updatedSuburbs}));
        }
      });
    } catch {
      alert("Error getting suburbs. Please refresh the page (F5) to try again");
    }
  }

  getStreets(filter) {
    try {
      API.get("colin", `/streets`, { queryStringParameters: filter }).then((streetOptions) => {
        if (streetOptions && this._isMounted) {
          this.setState((state) => ({ streetOptions }));
        }
      });
    } catch {
      alert("Error getting streets. Please refresh the page (F5) to try again");
    }
  }

  getTitleDetails() {
    try {
      API.get("colin", `/properties/${this.props.match.params.id}/parcels`, { queryStringParameters: null }).then((titleDetails) => {
        const state = this.state.state;

        if (["NSW", "QLD", "SA", "VIC", "WA"].includes(state)) {
          titleDetails.sort((a, b) => {
            return a.plan_number - b.plan_number || a.lot_number - b.lot_number;
          });
        } else if (["ACT"].includes(state)) {
          titleDetails.sort((a, b) => {
            return a.block - b.block || a.section - b.section;
          });
        }

        if (titleDetails) {
          this.setState((state) => ({ titleDetails }));
        }
      });
    } catch {
      console.log("Error getting parcels");
    }
  }

  getVolumeFolios(fromModal = false) {
    try {
      API.get("colin", `/properties/${this.props.match.params.id}/volume_folios`, { queryStringParameters: null }).then((volumeFolios) => {
        if (fromModal) {
          let updatedVolumeFolios = [...this.state.volumeFolios].map((uvf) => {
            const matchingVf = volumeFolios.find((vf) => vf.volume_folio_id === uvf.volume_folio_id);
            return matchingVf ? matchingVf : uvf;
          });
          this.setState({ volumeFolios: updatedVolumeFolios });
          return;
        }
        this.setState((state) => ({ volumeFolios }));
      });
    } catch {
      console.log("Error getting volume folios");
    }
  }

  validateRelatedRecord(record, set) {
    //property
    if (set === "property") {
      if (this.state.cityscope === null || this.state.map_number === null || this.state.property_number === null) {
        return [false, "Entries are required for Cityscope, Map No and Property No fields."];
      }

      // secondly check that UnitSort has been specified if required
      if (this.state.unit_number) {
        if (!this.state.unit_sort) {
          return [false, "Unit sort is required for unit entries."];
        }
      }

      if (this.state.email) {
        if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          return [false, "The email is not a correct format"];
        }
      }

      if (this.state.internet) {
        if (!this.state.internet.match(/^[\w.-]{3}(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)) {
          return [false, "The url (website) is not a correct format. Please enter www.{}.{}"];
        }
      }
    }

    //Address Validation
    if (set === "addresses") {
      //Check street name not blank
      if (record.street_name === "") {
        return [false, "ALERT!: Street name cannot be blank. Changes to this record WILL NOT BE SAVED until fixed."];
      }
      //Check only one main address
      if (record.main_address === true) {
        var mainCntr = 0;
        this.state.addresses.forEach(function (ad) {
          mainCntr = mainCntr + (ad.main_address ? 1 : 0);
        });
        console.log(mainCntr);
        if (mainCntr > 1) {
          return [false, "ALERT!: Only one main address is allowed. Changes to this record WILL NOT BE SAVED until fixed."];
        }
      }
      //Check sort order
      var res = this.state.addresses.reduce(function (obj, v) {
        obj[v.sort_order] = (obj[v.sort_order] || 0) + 1;
        return obj;
      }, {});
      const values = Object.values(res);
      for (const val of values) {
        if (val > 1) {
          return [false, "ALERT!: Duplicate sort orders. Changes to this record WILL NOT BE SAVED until fixed."];
        }
      }
    }

    if (set === "integrations") {
      return [true, null];
    }

    //leases Validation
    if (set === "leases") {
      // if (!record.lessee_trading && !record.lessee_registered && (record.include_cs_text || record.still_an_occ)) {

      //     return [false, "You have indicated the occupant is still there but have not provided lessee. Enter a lessee OR remove Include in Text AND Still Here"];
      // }

      if (record.registered) {
        if (!record.lease_number) {
          return [false, "Enter a lease number for lease id - " + record.lease_id];
        }
      }
      // if (record.include_cs_text && !record.lessee_trading) {
      //     return [false, "You have selected to include in Cityscope text but not entered a lessee"];
      // }
    }

    //leasing agents Validation
    if (set === "leasingAgent") {
      if (!record.entity_id_leasing_agent) {
        return [false, "You must select a leasing agent. The record has not been saved"];
      }
    }

    //Building Name Validation
    if (set === "buildingNames") {
      //Check building name is not null
      if (record.building_name === "") {
        console.log("In here");
        return [false, "Building Name cannot be blank. The record has not been saved"];
      }
      //Check sort order
      var res = this.state.buildingNames.reduce(function (obj, v) {
        obj[v.sort_order] = (obj[v.sort_order] || 0) + 1;
        return obj;
      }, {});
      const values = Object.values(res);
      for (const val of values) {
        if (val > 1) {
          return [false, "Duplicate sort orders. The record has not been saved"];
        }
      }
    }
    //building_grade_code
    if (set === "buildingGrades") {
      //Check building name is not null
      if (record.building_grade_code === null) {
        return [false, "Building Grade cannot be blank. The record has not been saved"];
      }
    }

    //Strata Unit Validation
    if (set === "strataUnits") {
      //Check building name is not null
      if (record.unit_sort === null || record.unit_sort === "") {
        console.log(record.unit_sort);
        return [false, "Unit Sort cannot be blank. The record has not been saved"];
      }
      //Check sort order
      var res = this.state.strataUnits.reduce(function (obj, v) {
        obj[v.unit_sort] = (obj[v.unit_sort] || 0) + 1;
        return obj;
      }, {});
      const values = Object.values(res);
      for (const val of values) {
        if (val > 1) {
          return [false, "Duplicate unit sorts. The record has not been saved"];
        }
      }
    }

    //Property Classification Validation
    if (set === "propertyClassifications") {
      //Check building name is not null
      if (record.classification_code === "") {
        console.log("In here");
        return [false, "Classification cannot be blank. The record has not been saved"];
      }
      //Check sort order
      var res = this.state.propertyClassifications.reduce(function (obj, v) {
        obj[v.sort_order] = (obj[v.sort_order] || 0) + 1;
        return obj;
      }, {});
      const values = Object.values(res);
      for (const val of values) {
        if (val > 1) {
          return [false, "Duplicate sort orders. The record has not been saved"];
        }
      }
    }

    //Lift Operator Validation
    if (set === "liftOperators") {
      console.log(record);
      //Check lift operator is not null
      //Validation not wanted
      //if (record.entity_id_lift_operator === null) {
      //    console.log("In here");
      //    return [false, "A lift operator must be selected. The record has not been saved"];
      //}

      //Check lift operator is in same state
      if (record.entity_id_lift_operator != null) {
        if (record.name.indexOf(this.state.state) === -1) {
          return [true, "The lift operator selected is in another state"];
        }
      }

      //Check sort order
      var res = this.state.liftOperators.reduce(function (obj, v) {
        obj[v.sort_order] = (obj[v.sort_order] || 0) + 1;
        return obj;
      }, {});
      const values = Object.values(res);
      for (const val of values) {
        if (val > 1) {
          return [false, "Duplicate sort orders. The record has not been saved"];
        }
      }
    }

    //Occupancy Rate Validation
    if (set === "occupancyRates") {
      //Check lift operator is in same state
      if (record.occupancy_percent != null) {
        if (record.occupancy_percent < 0 || record.occupancy_percent > 100) {
          return [false, "The occupancy percent must be between 0 and 100"];
        }
      }
    }

    return [true];
  }

  updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
  }

  saveRecord(record, endpoint, id) {
    record.last_edited_by = this.props.user;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        record.last_edited_by = this.props.user;
        if (endpoint === "propertyProposals" || endpoint === "propertySales" || endpoint === "propertyOwners" || endpoint === "propertySaleSheets" || endpoint === "propertyArticles" || endpoint === "properties") {
          return API.post("colin", `/${endpoint.toLowerCase()}/new`, {
            body: record,
          });
        } else if (endpoint === "titleDetails") {
          return API.post("colin", `/properties/${this.state.property_id}/parcels/${record[id]}`, { body: record });
        } else if (endpoint === "volumeFolios") {
          return API.post("colin", `/properties/${this.state.property_id}/volume_folios/${record[id]}`, { body: record });
        } else if (endpoint === "addresses") {
          let appended_record = record;
          appended_record.suburb = this.state.suburb;
          appended_record.state = this.state.state;
          appended_record.postcode = this.state.postcode;
          appended_record.unit_number = this.state.unit_number;
          appended_record.unit_number_suffix = this.state.unit_number_suffix;
          appended_record.property_key = this.state.property_key;
          return API.post("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/new`, { body: appended_record });
        } else {
          return API.post("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/new`, {
            body: record,
          });
        }
      }
    }
    //If not a new record and updating an existing, perform a put
    //First condition looks after many to many relationships
    if (endpoint === "propertyProposals" || endpoint === "propertySales" || endpoint === "propertyOwners" || endpoint === "propertySaleSheets" || endpoint === "propertyArticles" || endpoint === "properties") {
      return API.put("colin", `/${endpoint.toLowerCase()}/${record[id]}`, {
        body: record,
      });
    } else if (endpoint === "titleDetails") {
      return API.put("colin", `/properties/${this.state.property_id}/parcels/${record[id]}`, { body: record });
    } else if (endpoint === "volumeFolios") {
      return API.put("colin", `/properties/${this.state.property_id}/volume_folios/${record[id]}`, { body: record });
    } else if (endpoint === "addresses") {
      let appended_record = record;
      appended_record.suburb = this.state.suburb;
      appended_record.state = this.state.state;
      appended_record.postcode = this.state.postcode;
      appended_record.unit_number = this.state.unit_number;
      appended_record.unit_number_suffix = this.state.unit_number_suffix;
      return API.put("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/${record[id]}`, { body: appended_record });
    } else if (endpoint === "propertyIntegrations") {
      return API.put("colin", `/properties/${this.state.property_id}/integrations/${record[id]}`, { body: record });
    } else if (endpoint.includes("_batch")) {
      return API.put("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/${id}`, { body: record });
    } else {
      return API.put("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/${record[id]}`, {
        body: record,
      });
    }
  }

  saveAddressesRecord(record, endpoint, id) {
    this.setState({ addressSaved: true });
    record.suburb = this.state.suburb;
    record.state = this.state.state;
    record.postcode = this.state.postcode;
    const saveRecordPromise = this.saveRecord(record, endpoint, id);
    /* saveRecordPromise.then(response => {
            if (response.result === true) {
                this.getIntegrations();
            }
        }); */

    return saveRecordPromise;
  }

  async updateIntegrations() {
    console.log("updating Integrations");
    console.log(this.state.addresses);

    try {
      const address = this.state.addresses[0];
      await this.saveRecord(address, "addresses", "street_address_id");
      await this.getIntegrations();
    }
    catch (error) {
      console.warn(`Address 0 not found in ${this.state.addresses}`);
      return;
    }
  }

  async saveIntegration(integration) {
    integration.last_edited_date = new Date();
    integration.last_edited_by = this.props.user;

    const response = await API.put("colin", `/properties/${this.state.property_id}/integrations/${integration.property_integration_id}`, {
      body: integration,
    });

    return integration;
  }

  acceptIntegration(row, e) {
    row.original.is_accepted = true;
    row.original.accept_reject_by = this.props.user;

    this.saveIntegration(row.original);
    this.setState(this.state);
  }

  rejectIntegration(row, e) {
    row.original.is_accepted = false;
    row.original.accept_reject_by = this.props.user;

    this.saveIntegration(row.original);
    this.setState(this.state);
  }

  generateNabersValues() {
    let nabersRatingValues = [...this.state.nabersRatingValues];
    var i;
    for (i = 0.0; i <= 6; ) {
      nabersRatingValues.push({ label: i, value: i });
      i = Math.round((i + 0.5) * 1e12) / 1e12;
    }
    this.setState({ nabersRatingValues });
  }

  handleSuburbChange = (selectedSuburb) => {
    this.setState(
      {
        selectedSuburb,
        suburb: selectedSuburb.suburb,
        state: ["AK", "WN", "CC"].indexOf(this.state.cityscope) >= 0 ? "NZ" : selectedSuburb.state,
        postcode: selectedSuburb.postcode,
        modified: true,
      },
      async () => {
        // This callback function will be executed after handleBlur has finished running
        this.handleBlur();
        for (let index = 0; index < this.state.addresses.length; index++) {
          console.log(index);
          const address = this.state.addresses[index];
          const result = await this.saveAddressesRecord(address, "addresses", "street_address_id");
          const result2 = await this.getIntegrations();
        }
      }
    );
  };

  handleCityscopeChange = async (selectedCityscope) => {
    this.setState({
      selectedCityscope,
      cityscope: selectedCityscope.value,
      suburbFilter: { cityscope: this.state.cityscope },
      modified: true,
    });
    await this.getSuburbs(this.state.suburbFilter);
  };

  handleAgentSearch = async () => {
    try {
      if (this.state.showAgentDropDown) {
        this.setState((state) => ({
          showAgentDropDown: false,
        }));
      }
      let state = null;
      if (!this.state.agentInterstateFlag) {
        state = this.state.state;
      }
      await this.getAgents({ name: this.state.agentSearchString, state: state });

      this.setState((state) => ({
        showAgentDropDown: true,
      }));
      this.setState({ agentMenuIsOpen: true });
    } catch {
      alert("Error loading agents");
    }
  };

  handleEnterOnAgentSearch = (e) => {
    if (e.keyCode === 13) {
      this.handleAgentSearch();
    }
  };

  handleAgentChange = async (selectedAgent) => {
    this.setState({
      selectedAgentContact: { value: null, label: null },
      entity_contact_id_managing_agent: null,
      managing_agent_contact: null,
      managing_agent_email: "",
    });

    if (selectedAgent) {
      this.setState(
        {
          selectedAgent,
          entity_id_managing_agent: selectedAgent.value,
          managing_agent: selectedAgent.label,
          managing_agent_email: selectedAgent.email,
          modified: true,
        },
        this.handleBlur
      );
      //Get contacts
      await this.getAgentContacts({ entityid: selectedAgent.value });

      this.setState((state) => ({ showAgentContactDropDown: true }));
    } else {
      this.setState(
        {
          entity_id_managing_agent: null,
          managing_agent: null,
          selectedAgent: { value: null, label: null },
          entity_contact_id_managing_agent: null,
          managing_agent_contact: null,
          modified: true,
        },
        this.handleBlur
      );
      this.setState((state) => ({ showAgentContactDropDown: false }));
    }
    this.setState({ agentMenuIsOpen: false });
  };

  handleAgentContactChange = (selectedAgentContact) => {
    if (selectedAgentContact) {
      this.setState(
        {
          entity_contact_id_managing_agent: selectedAgentContact.value,
          managing_agent_contact: selectedAgentContact.label,
          selectedAgentContact,
          modified: true,
        },
        this.handleBlur
      );
    } else {
      this.setState(
        {
          selectedAgentContact: { value: null, label: null },
          entity_contact_id_managing_agent: null,
          managing_agent_contact: null,
          modified: true,
        },
        this.handleBlur
      );
    }
  };

  handleEnterCurrentIdIndex = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      this.handleGoToRecord();
    }
  };

  handleGoToRecord = (event) => {
    console.log(this.state.idList.length);
    if (this.state.currentIdIndex >= 0 && this.state.currentIdIndex < this.state.idList.length) {
      this.props.history.push({ pathname: `/properties/${this.state.idList[this.state.currentIdIndex]}`, state: { data: this.state.idList } });
    } else {
      alert("Page no not in range.");
    }
  };

  handleCurrentIdIndexChange = (event) => {
    const val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({ [event.target.id]: val - 1 });
  };

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
    this.setState({ modified: true });
    if (event.target.id === "unit_number") {
      if (this.state.unit_number) {
        this.setState((state) => ({ disableSubDividedUnit: false }));
      } else {
        this.setState((state) => ({ disableSubDividedUnit: true }));
      }
    }

    if (event.target.id === "cityscope") {
      this.setState({ [event.target.id]: event.target.value.toUpperCase() });
    }
  };

  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.%]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleDateChange(date, name) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    var dt = new Date(date);

    if (date) {
      this.setState({
        [name]: dt.toLocaleDateString("en-AU", options),
        modified: true,
      });
    } else {
      this.setState({
        [name]: null,
        modified: true,
      });
    }
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
    this.setState(
      {
        [name]: event.target.checked,
        modified: true,
      },
      this.handleBlur
    );

    if (name === "sub_divided_unit") {
      alert("NOTE: The idea behind flagging a unit record as a 'subdivided unit' is so it will be excluded from proofing queries. The record will appear to the customer in both hard copy and database products.");
    }
  };

  async buildPropertyKey() {
    let property_key = this.state.cityscope + (this.state.map_number || "").toString() + (this.state.map_number_suffix || "") + "." + (this.state.property_number || "").toString() + (this.state.property_number_suffix || "");

    if (this.state.unit_number !== null && this.state.unit_number !== "") {
      property_key = property_key + "." + (this.state.unit_number.toString() | "") + (this.state.unit_number_suffix || "");
    }
    if (property_key !== !this.state.property_key) {
      this.setState((state) => ({ property_key }));
      this.setState((state) => ({ reloadPage: true }));
    }
    return true;
  }

  handleRenumber = async (event) => {
    const confirmed = window.confirm("Are you sure you want to renumber " + this.state.property_key + " to " + this.state.cityscope + (this.state.map_number || "").toString() + (this.state.map_number_suffix || "") + "." + (this.state.property_number || "").toString() + (this.state.property_number_suffix || "") + (this.state.unit_number ? "." + (this.state.unit_number.toString() | "") + (this.state.unit_number_suffix || "") : "") + " (including any strata units)?");

    if (!confirmed) {
      return;
    } else {
      this.handleBlur(event, async () => {
        // This callback function will be executed after handleBlur has finished running
        this.handleBlur();
        for (let index = 0; index < this.state.addresses.length; index++) {
          console.log(index);
          const address = this.state.addresses[index];
          const result = await this.saveAddressesRecord(address, "addresses", "street_address_id");
          const result2 = await this.getIntegrations();
        }
      });
    }
  };

  handleBlur = async (event) => {
    if (event) event.persist();

    if (this.state.modified === true) {
      // New logic per http://jira.ad.corelogic.asia/browse/CITY-3
      if (event && event.target.id === "building_area" && (!this.state.disableSubDividedUnit || this.state.head_record_property_id)) {
        const moveValue = window.confirm("Please note: Building Area is typically not be populated for Unit records. Would you like to move the value entered into the Unit Area field?");

        if (moveValue) {
          this.setState({ unit_area: this.state.building_area });
          this.setState({ building_area: "" });
        }
      } else if (event && event.target.id === "unit_area" && this.state.disableSubDividedUnit && this.state.unit_area) {
        const moveValue = window.confirm("Please note: Unit Area is typically not be populated for non-unit records. Would you like to move the value entered into the Building Area field?");

        if (moveValue) {
          this.setState({ building_area: this.state.unit_area });
          this.setState({ unit_area: "" });
        }
      }

      console.log("in handleblur");
      await this.buildPropertyKey();
      // for (let index = 0; index < this.state.addresses.length; index++) {
      //     const address = this.state.addresses[index];
      //     const result = await this.saveAddressesRecord(address,'addresses',"street_address_id")
      //     const result2 = await this.getIntegrations();
      // }
      this.setState({ showAlert: false, last_edited_by: this.props.user });
      const result = await this.syncroniseState();

      const validation = this.validateRelatedRecord(this.state.property, "property");

      if (validation[0] === true) {
        if (this.state.entity_id_managing_agent) {
          if (this.state.managing_agent.indexOf("INACTIVE") > 0) {
            this.setState({ errorMessage: "You have selected an inactive managing agent, please consider if this is correct. The record will still be saved." });
            this.setState({ showAlert: true });
          }
          if (this.state.state) {
            if (this.state.managing_agent.toUpperCase().indexOf(this.state.state.toUpperCase()) === -1) {
              this.setState({ errorMessage: "You have selected a managing agent in another state, please consider if this is correct. The record will still be saved." });
              this.setState({ showAlert: true });
            }
          }
        }

        try {
          this.setState((state) => ({ modified: false }));
          if (this.props.match.params.id === "new") {
            this.setState({ isLoading: true });
          }
          const result = await this.saveProperty(this.state.property);
          this.setState({ isLoading: false });

          if (result.result === false) {
            if (result.error_message !== "") {
              alert(result.error_message);
            } else {
              const confirmed = window.confirm("The record has been updated by another user. Do you want to force your changes through (this will overwrite changes from the other user)?");

              if (!confirmed) {
                return;
              } else {
                this.setState({ isLoading: true });
                const result = await this.saveProperty(this.state.property, true);
                this.setState({ isLoading: false });
                if (result.result === false) {
                  if (result.error_message !== "") {
                    alert(result.error_message);
                  } else {
                    alert("The force change did not work. Please reload the page and apply changes again.");
                  }
                } else {
                  this.setState({ showCityscopeReference: false, last_edited_date: result.last_edited_date });
                }
              }
            }
          } else {
            this.setState({ showCityscopeReference: false, last_edited_date: result.last_edited_date }, () => {
              if (this.props.match.params.id === "new") {
                this.setState((state) => ({ property_id: result.id }));
                console.log("New property created: property key " + this.state.property_key);
                this.props.history.push("/properties/" + this.state.property_key);
              }

              if (this.state.reloadPage) {
                this.props.history.push("/properties/" + this.state.property_key);
              }

              if (event && event.target.id === "title_details_postamble") {
                this.updateTitleDetailsString();
              }
            });
          }
        } catch (e) {
          alert(e);
        }
      } else {
        this.setState({ errorMessage: validation[1] });
        this.setState({ showAlert: true });
      }
    }
  };

  toggleAddressModal = async () => {
    await this.setState((state) => ({
      showAddressDialog: !this.state.showAddressDialog,
    }));

    if (!this.state.showAddressDialog && this.state.addressSaved) {
      this.setState({ isLoading: true });
      await this.getIntegrations();
      this.setState({ isLoading: false });
      this.setState({ addressSaved: false });
      this.togglePropertyIntegrationsModal();
    }
  };

  togglePropertyIntegrationsModal = async () => {
    this.setState((state) => ({
      showAddressMatchingDialog: !this.state.showAddressMatchingDialog,
    }));
  };

  toggleTitleDetailsModal = async () => {
    await this.setState((state) => ({
      showTitleDetailsDialog: !this.state.showTitleDetailsDialog,
    }));

    if (this.state.showTitleDetailsDialog === false) {
      this.updateTitleDetailsString();
    }
  };

  toggleVolumeFoliosModal = async () => {
    await this.setState((state) => ({
      showVolumeFoliosDialog: !this.state.showVolumeFoliosDialog,
    }));

    if (this.state.showVolumeFoliosDialog === false) {
      this.updateTitleDetailsString();
    }
  };

  handleHold = async () => {
    let withholdings = [...this.state.withholdings];
    withholdings.push({
      property_key: this.state.property_key,
      withholding_reason_id: this.props.withholdingReasons.find((o) => o.label === "User Flagged").value,
      withholding_reason: "User Flagged",
      withholding_text: null,
      primary_classification_code: this.state.propertyClassifications.length > 0 ? this.state.propertyClassifications[0].classification_code : null,
      primary_classification: this.state.propertyClassifications.length > 0 ? this.state.propertyClassifications[0].classification : null,
      link_id: null,
      link: null,

      property_id: this.state.property_id,
      scoped_by: this.props.user,
      created_by: this.props.user,
      last_edited_by: this.props.user,
      new_record: true,
      modified: true,
      selected: false,
    });
    this.setState({ withholdings });
    this.toggleWithholdingModal();
  };

  toggleWithholdingModal = async () => {
    this.setState((state) => ({
      showWithholdingDialog: !this.state.showWithholdingDialog,
    }));
  };

  togglePropertyAddModal = async () => {
    let properties = [...this.state.properties];
    let property = {};
    property.cityscope = this.state.cityscope;
    property.map_number = this.state.map_number;
    property.map_number_suffix = this.state.map_number_suffix;
    property.property_number = this.state.property_number;
    property.property_number_suffix = this.state.property_number_suffix;
    property.unit_number = this.state.unit_number;
    property.unit_number_suffix = this.state.unit_number_suffix;
    property.unit_sort = this.state.unit_sort;
    property.description = this.state.description;
    property.unit_area = this.state.unit_area;
    property.unit_level_number = this.state.unit_level_number;
    property.bedrooms = this.state.bedrooms;
    property.parking_yes_no = this.state.parking_yes_no;
    property.parking_num = this.state.parking_num;
    property.title_details = this.state.title_details;
    property.title_details_postamble = this.state.title_details_postamble;
    property.title_details_archive = this.state.title_details_archive;
    property.suburb = this.state.suburb;
    property.postcode = this.state.postcode;
    property.state = this.state.state;
    property.zoning_text = this.state.zoning_text;
    property.photo_required = false;
    property.created_by = this.props.user;
    property.last_edited_by = this.props.user;
    property.sub_divided_unit = false;

    if (properties.length == 0) {
      //Takes a copy of the current
      property.property_id = null;
      property.new_record = true;
      properties.push(property);
    }
    this.setState(
      (state) => ({
        properties,
        showPropertyAddDialog: !this.state.showPropertyAddDialog,
      }),
      () => {
        if (this.state.showPropertyAddDialog == false) {
          this.setState({ properties: [] });
          if (this.state.unit_number === null) {
            try {
              this.state.property && this.getStrataUnits(this.state.strataUnitFilter);
            } catch {
              alert("Error loading building names");
            }
          } else {
            this.setState({ strataUnits: [] });
          }
        }
      }
    );
  };

  toggleBuildingNameModal = () => {
    this.setState({
      showBuildingNameDialog: !this.state.showBuildingNameDialog,
    });
  };

  toggleBuildingGradeModal = () => {
    this.setState({
      showBuildingGradeDialog: !this.state.showBuildingGradeDialog,
    });
  };

  togglePropertyClassificationModal = () => {
    this.setState({
      showPropertyClassificationDialog: !this.state.showPropertyClassificationDialog,
    });
  };

  toggleCityscopeReference = () => {
    this.setState({
      orig_cityscope: this.state.cityscope,
      orig_map_number: this.state.map_number,
      orig_map_number_suffix: this.state.map_number_suffix,
      orig_property_number: this.state.property_number,
      orig_property_number_suffix: this.state.property_number_suffix,
      orig_unit_number: this.state.unit_number,
      orig_unit_number_suffix: this.state.unit_number_suffix,
      orig_unit_sort: this.state.unit_sort,
    });

    this.setState({
      showCityscopeReference: !this.state.showCityscopeReference,
    });
  };

  cancelCityscopeReferenceChange = () => {
    if (this.state.property_id != null) {
      this.setState({
        orig_cityscope: this.state.orig_cityscope,
        map_number: this.state.orig_map_number,
        map_number_suffix: this.state.orig_map_number_suffix,
        property_number: this.state.orig_property_number,
        property_number_suffix: this.state.orig_property_number_suffix,
        unit_number: this.state.orig_unit_number,
        unit_number_suffix: this.state.orig_unit_number_suffix,
        unit_sort: this.state.orig_unit_sort,
      });
      this.setState({
        showCityscopeReference: !this.state.showCityscopeReference,
      });
    } else {
      this.props.history.push("../properties");
    }
  };

  async refreshPropertyOwners() {
    console.log("In refreshPropertyOwners");
    if (!this.state.showOwnerSearchDialog) {
      const propertyOwners = await this.getPropertyOwners(this.state.propertyOwnerFilter);
      if (propertyOwners && this._isMounted) {
        this.setState((state) => ({ propertyOwners }));
      }
    }
  }
  toggleOwnerSearchDialog = async () => {
    console.log("In toggleOwnerSearchDialog");
    this.setState(
      {
        showOwnerSearchDialog: !this.state.showOwnerSearchDialog,
      },
      this.refreshPropertyOwners
    );
  };

  handleCopyPropertyOwners = async () => {
    if (this.state.copyPropertyOwner != null) {
      let confirmed = window.confirm("Are you sure you want to copy owners from " + this.state.copyPropertyOwner + "?");
      if (confirmed) {
        let propertyOwner = {
          property_id: this.state.property_id,
          created_by: this.props.user,
          last_edited_by: this.props.user,
        };

        const result = await this.copyPropertyOwners(propertyOwner);
        if (result.result === false) {
          alert(result.error_message);
        } else {
          console.log("success");
          try {
            const propertyOwners = await this.getPropertyOwners(this.state.propertyOwnerFilter);
            if (propertyOwners && this._isMounted) {
              this.setState((state) => ({ propertyOwners }));
            }
          } catch {
            alert("Error loading property owners");
          }
        }
      }
    } else {
      alert("Enter a cityscope reference to copy owners from");
    }
  };

  /**
   * Gets the user selected strata units.
   * @returns The strata units that the user selected.
   */
  getSelectedUnits() {
    return this.state.strataUnits.filter((unit) => unit.selected)
  }

  handleCopyBuildingNamesToStrata = async (event) => {
    event.preventDefault();

    let confirmed = window.confirm("Are you sure you want to copy head record Building Names to the selected units? Note that any existing Building Name records for the selected units will be deleted and replaced as part of the copy process.\n\nNote: This process can take some time. CoLin will prevent you from making further edits until the copy process is complete.");
    if (confirmed) {
      await this.setState({ isLoading: true });
      const parameters = {
        created_by: this.props.user,
        last_edited_by: this.props.user,
      };
      const selectedUnitIDs = this.getSelectedUnits().map((unit) => unit.property_id);
      const result = await this.updateStrataBuilingNameBatch(selectedUnitIDs, parameters);

      if (result.result === false) {
        alert(result.error_message);
      }

      await this.setState({ isLoading: false });
      alert("Copy complete");
    }
  };

  handleCopyClassificationsToStrata = async (event) => {
    event.preventDefault();
    let confirmed = window.confirm("Are you sure you want to copy head record Classifications to the selected units? Note that any existing Classification records for the selected units will be deleted and replaced as part of the copy process.\n\nNote: This process can take some time. CoLin will prevent you from making further edits until the copy process is complete.");
    if (confirmed) {
      await this.setState({ isLoading: true });
      const parameters = {
        created_by: this.props.user,
        last_edited_by: this.props.user,
      };
      const selectedUnitIDs = this.getSelectedUnits().map((unit) => unit.property_id);
      const result = await this.updateStrataPropertyClassificationBatch(selectedUnitIDs, parameters);

      if (result.result === false) {
        alert(result.error_message);
      }

      await this.setState({ isLoading: false });
      alert("Copy complete");
    }
  };

  handleCopyAddressesToStrata = async (event) => {
    event.preventDefault();
    let confirmed = window.confirm("Are you sure you want to copy head record Street Addresses to the selected units? Note that any existing Street Address records for the selected units will be deleted and replaced as part of the copy process. The address matching for CoreLogic Equivalent Properties will also be re-run for each selected unit.\n\nNote: Suburb+State+Post Code are NOT included in the Street Address copy. Use the “Copy Suburb+State+PC” for this function.\n\nNote: This process can take some time. CoLin will prevent you from making further edits until the copy process is complete.");
    if (confirmed) {
      await this.setState({ isLoading: true });

      const parameters = {
        created_by: this.props.user,
        last_edited_by: this.props.user,
      };
      const selectedUnitIDs = this.getSelectedUnits().map((unit) => unit.property_id);
      const result = await this.updateStrataStreetAddressBatch(selectedUnitIDs, parameters);

      if (result.result === false) {
        alert(result.error_message);
      }

      await this.setState({ isLoading: false });
      alert("Copy complete");
    }
  };

  handleCopyPropertySuburb = async (event) => {
    event.preventDefault();

    const suburbStatePostcodePrompt = ` is not set on this Head Record (${this.state.property_key}). Copy anyway?`;
    if (!window.confirm("Are you sure you want to copy the head record property Suburb, State, and Post Code to the selected units? The address matching for CoreLogic Equivalent Properties will also be re-run for each selected unit.\n\nNote: This process can take some time. CoLin will prevent you from making further edits until the copy process is complete.")) return;
    if (!this.state.suburb && !window.confirm("Suburb" + suburbStatePostcodePrompt)) return;
    if (!this.state.state && !window.confirm("State" + suburbStatePostcodePrompt)) return;
    if (!this.state.postcode && !window.confirm("Postcode" + suburbStatePostcodePrompt)) return;

    await this.setState({ isLoading: true });
    
    const parameters = {
      last_edited_by: this.props.user,
      suburb: this.state.suburb,
      state: this.state.state,
      postcode: this.state.postcode,
    };
    const selectedUnitIDs = this.getSelectedUnits().map((unit) => unit.property_id);
    const result = await this.updateStrataSuburbBatch(selectedUnitIDs, parameters);

    if (result.result === false) {
      alert(result.error_message);
    }

    await this.setState({ isLoading: false });
    alert("Copy complete");
  };

  handleCopyOwnersToStrata = async (event) => {
    event.preventDefault();
    let confirmed = window.confirm("Are you sure you want to copy head record Property Owner(s) to the selected units? Please Note: Should any of the selected Units have existing Property Owner(s), you will be prompted to make the decision to overwrite or retain the pre-existing Property Owner(s).\n\nNote: This process can take some time. CoLin will prevent you from making further edits until the copy process is complete.");
    if (confirmed) {
      await this.setState({ isLoading: true });
      
      let unitsToUpdate = [];
      for (var i = 0; i < this.state.strataUnits.length; i++) {
        if (this.state.strataUnits[i].owner_count > 0) {
          let confirmed = window.confirm("Unit: " + this.state.strataUnits[i].property_key + " has owners linked to the property. Click OK to overwrite the existing Property Owner(s) for this unit, or Cancel to skip the copy for this unit, and retain the pre-existing Property Owner(s).");
          if (confirmed) {
            unitsToUpdate.push(this.state.strataUnits[i].property_id);
          }
        }
        else if (this.state.strataUnits[i].owner_count == 0) {
          unitsToUpdate.push(this.state.strataUnits[i].property_id);
        }
      }

      const parameters = {
        created_by: this.props.user,
        last_edited_by: this.props.user,
      };
      const selectedUnitIDs = this.getSelectedUnits().filter((unit) => unitsToUpdate.includes(unit.property_id)).map((unit) => unit.property_id);
      const result = await this.updateStrataPropertyOwnerBatch(selectedUnitIDs, parameters);

      if (result.result === false) {
        alert(result.error_message);
      }

      await this.setState({ isLoading: false });
      alert("Copy complete");
    }
  };

  handleCopyParcelsToStrata = async (event) => {
    event.preventDefault();
    let confirmed = window.confirm("Are you sure you want to copy head record Parcels to the selected units? Note that any existing unit record Parcels will be deleted and replaced as part of the copy process. The unit record Unit Number will automatically be allocated as the Lot Number for the Parcel for each strata unit record.\n\nNote: This process can take some time. CoLin will prevent you from making further edits until the copy process is complete.");
    if (confirmed) {
      await this.setState({ isLoading: true });


      const parameters = {
        created_by: this.props.user,
        last_edited_by: this.props.user,
      };
      const selectedUnitIDs = this.getSelectedUnits().map((unit) => unit.property_id);
      const result = await this.updateStrataTitleReferenceBatch(selectedUnitIDs, parameters);

      if (result.result === false) {
        alert(result.error_message);
      }
    
      await this.setState({ isLoading: false });
      alert("Copy complete");
    }
  };
  

  handleDelete = async (event) => {
    event.preventDefault();

    const confirmed = window.confirm("Are you sure you want to delete the property - " + this.state.property_key + "?");

    if (!confirmed) {
      return;
    } else {
      const confirmed2 = window.confirm("FINAL WARNING. Deleting this property ( " + this.state.property_key + ") will mean you cannot access it anymore. Do you want to continue?");

      if (!confirmed2) {
        return;
      } else {
        this.setState({ archived_date: new Date() }, () =>
          this.syncroniseState().then(async () => {
            console.log(this.state.archive_date);
            const result = await this.saveProperty(this.state.property);
            if (result.result === false) {
              alert(result.error_message);
            } else {
              this.props.history.push("/properties");
            }
          })
        );
      }
    }
  };

  //Pulls data required for tabs. If tabindex changes this function will need to change
  onTabSelect = async (tabindex) => {
    this.setState({ tabKey: tabindex });
    console.log(tabindex);
    switch (tabindex) {
      case "1":
        console.log("Leases tab clicked");
        try {
          this.state.property && this.getLeases({ propertyid: this.state.property_id, archived: null });
        } catch {
          alert("Error loading leases");
        }
        break;

      // case "13":
      //     try {
      //         const propertyArticles = await this.getPropertyArticles(this.state.articleFilter);
      //         console.log(propertyArticles);
      //         if(propertyArticles){
      //             console.log("In article loop");
      //             for(var i=0;i<propertyArticles.length;i++){
      //                 const url = await s3GetURL(propertyArticles[i].file_name+"."+propertyArticles[i].file_type,'article')
      //                 if(url){
      //                     propertyArticles[i].url= url;
      //                 }
      //             }
      //             this.setState({propertyArticles});
      //         }
      //     }
      //     catch{
      //         console.log("Error loading articles");
      //     }
      //     break;
      // case "12":
      //     if(this.state.unit_number===null){
      //         try {
      //             this.state.property && this.getStrataUnits(this.state.strataUnitFilter);
      //         }
      //         catch{
      //             alert("Error loading strata units");
      //         }
      //     }
      //     else{
      //         this.setState({strataUnits: []});
      //     }
      //     break;
      case "3":
        try {
          this.state.property && this.getOccupancyRates(this.state.occupancyFilter);
        } catch {
          alert("Error loading occupancy rates");
        }
        break;
      case "2":
        try {
          this.state.property && this.getLeasingAgents(this.state.leaseFilter);
        } catch {
          alert("Error loading leasing agents");
        }
        break;
      case "6":
        try {
          this.state.property && this.getLiftOperators(this.state.liftOperatorFilter);
        } catch {
          alert("Error loading lift operators");
        }
      case "5":
        try {
          this.state.property && this.getNabers(this.state.naberFilter);
        } catch {
          alert("Error loading nabers");
        }
        break;
      case "4":
        try {
          this.state.property && this.getPropertyProposals(this.state.proposalFilter);
        } catch {
          alert("Error loading proposals");
        }
        break;
      // case "9":
      //     try {

      //         const propertyOwners = await this.getPropertyOwners({propertyid: this.state.property_id});
      //         if (propertyOwners && this._isMounted) {
      //             this.setState(state => ({ propertyOwners }));
      //         }
      //     }
      //     catch(error){
      //         alert("Error loading property owners."+ error);
      //     }
      //     break;
      // case "10":
      //     try {
      //         this.state.property && this.getQueries(this.state.queryFilter);
      //     }
      //     catch{
      //         alert("Error loading queries");
      //     }
      //     break;
      // case "8":
      //     try {
      //         console.log("In get property sales: sale filter "+this.state.saleFilter);
      //         this.state.property && await this.getPropertySales({propertyid: this.state.property_id});
      //     }
      //     catch{
      //         alert("Error loading sales");
      //     }
      //     break;
      // case "11":
      //     try {
      //         this.state.property && this.getPropertySalesSheets(this.state.saleSheetFilter);
      //     }
      //     catch{
      //         alert("Error loading sale sheets");
      //     }
      //     break;
    }
  };

  async updateTitleDetailsString() {
    const response = await this.getProperty();
    await this.setState({ title_details: response.title_details });

    // const validVfs = [...this.state.volumeFolios].filter(vf => (!!vf.volume && !!vf.folio) || !!vf.other);
    // const validTds = [...this.state.titleDetails].filter(td => !!td.jurisdiction_id);
    // let newTitleDetailsStr = '';

    // if (validTds.length > 0) {
    //     const tdsString = validTds.map(td => td.jurisdiction_id).join(', ');
    //     newTitleDetailsStr += `RPD: ${tdsString||''}. `;
    // }

    // if (validVfs.length > 0) {
    //     const vfsString = validVfs.map(vf => {
    //         if (vf.volume && vf.folio) { return `V${vf.volume} F${vf.folio}` }
    //         return vf.other
    //     }).join(', ')
    //     newTitleDetailsStr += `Title Ref: ${vfsString||''}. `;
    // }

    // if (this.state.title_details_postamble) {
    //     newTitleDetailsStr += this.state.title_details_postamble;
    // }

    // await this.setState({ title_details: newTitleDetailsStr.trim() });

    // const property = {...this.state.property};
    // property.title_details = newTitleDetailsStr;
    // this.saveProperty(property);
  }

  render() {
    return (
      <div className="Property">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css={css`
                  display: block;
                  margin: 0 auto;
                  border-color: red;
                `}
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {this.state.showOwnerSearchDialog && <OwnerSearchModal isAuthenticated={this.props.isAuthenticated} user={this.props.user} toggleOwnerSearchDialog={this.toggleOwnerSearchDialog} properties={[{ property_key: this.state.property_key }]} show={this.state.showOwnerSearchDialog} />}
        {this.state.showAddressDialog && <AddressModal show={this.state.showAddressDialog} onClose={this.toggleAddressModal} filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} toggleAddressModal={this.toggleAddressModal} user={this.props.user} data={this.state.addresses} updateTableState={this.updateTableState} saveRecord={this.saveAddressesRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} streetOptions={this.state.streetOptions} />}

        {this.state.showAddressMatchingDialog && <PropertyIntegrationsModal show={this.state.showAddressMatchingDialog} onClose={this.togglePropertyIntegrationsModal} filter={this.state.integrationFilter} isAuthenticated={this.props.isAuthenticated} toggleAddressModal={this.togglePropertyIntegrationsModal} user={this.props.user} data={this.state.integrations} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} streetOptions={this.state.streetOptions} acceptIntegration={this.acceptIntegration} rejectIntegration={this.rejectIntegration} ctx="cs" />}
        {this.state.showTitleDetailsDialog && <TitleDetailsModal show={this.state.showTitleDetailsDialog} onClose={this.toggleTitleDetailsModal} filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} toggleTitleDetailsModal={this.toggleTitleDetailsModal} user={this.props.user} data={this.state.titleDetails} dataFetch={this.getTitleDetails} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} stateCode={this.state.state} />}

        {this.state.showVolumeFoliosDialog && <VolumeFoliosModal show={this.state.showVolumeFoliosDialog} onClose={this.toggleVolumeFoliosModal} filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} toggleVolumeFoliosModal={this.toggleVolumeFoliosModal} user={this.props.user} data={this.state.volumeFolios} dataFetch={this.getVolumeFolios} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} />}

        {this.state.showWithholdingDialog && <WithholdingsModal show={this.state.showWithholdingDialog} onClose={this.toggleWithholdingModal} filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} toggleWithholdingModal={this.toggleWithholdingModal} user={this.props.user} data={this.state.withholdings} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} withholdingReasons={this.props.withholdingReasons} userPermissions={this.props.userPermissions} />}

        {this.state.showPropertyAddDialog && <PropertyAddModal show={this.state.showPropertyAddDialog} onClose={this.togglePropertyAddModal} filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} togglePropertyAddModal={this.togglePropertyAddModal} user={this.props.user} data={this.state.properties} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} cityscopeOptions={this.state.cityscopeOptions} propertyid={this.state.property_id} suburbOptions={this.state.suburbOptions} />}

        {this.state.showBuildingNameDialog && <BuildingNameModal show={this.state.showBuildingNameDialog} onClose={this.toggleBuildingNameModal} filter={this.state.buildingNameFilter} isAuthenticated={this.props.isAuthenticated} toggleBuildingNameModal={this.toggleBuildingNameModal} user={this.props.user} data={this.state.buildingNames} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} />}
        {this.state.showPropertyClassificationDialog && <PropertyClassificationModal show={this.state.showPropertyClassificationDialog} onClose={this.togglePropertyClassificationModal} filter={this.state.propertyClassificationFilter} isAuthenticated={this.props.isAuthenticated} togglePropertyClassificationModal={this.togglePropertyClassificationModal} user={this.props.user} data={this.state.propertyClassifications} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} classificationOptions={this.props.classificationOptions} validateRelatedRecord={this.validateRelatedRecord} />}
        {this.state.showBuildingGradeDialog && <BuildingGradeModal show={this.state.showBuildingGradeDialog} onClose={this.toggleBuildingGradeModal} filter={this.state.buildingGradeFilter} isAuthenticated={this.props.isAuthenticated} toggleBuildingGradeModal={this.toggleBuildingGradeModal} user={this.props.user} data={this.state.buildingGrades} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} buildingGradeSourceOptions={this.props.buildingGradeSourceOptions} buildingGradeOptions={this.props.buildingGradeOptions} validateRelatedRecord={this.validateRelatedRecord} />}
        {this.state.property && this.props.isAuthenticated && !this.state.isLoading && (
          <div className="PropertyForm">
            <Form>
              <Form.Row>
                <Col>
                  <h6 class="text-nowrap">
                    Property Details - {this.state.property_key} | {this.state.addresses.length > 0 ? this.state.addresses[0].street_address : ""} | {this.state.buildingNames.length > 0 ? this.state.buildingNames[0].building_name : ""} {this.state.archived_date && <font color="red"> || *** ARCHIVED ***</font>}
                  </h6>
                </Col>
                <Col>
                  <Nav className="justify-content-end">
                    {this.state.previousId !== null && this.state.idList.length > 0 && (
                      <Nav.Item>
                        <LinkContainer to={{ pathname: `/properties/${this.state.previousId}`, state: { data: this.state.idList } }}>
                          <Button type="button" variant="info" size="sm">
                            Previous
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}

                    {this.state.nextId !== null && this.state.idList.length > 0 && (
                      <Nav.Item>
                        <LinkContainer to={{ pathname: `/properties/${this.state.nextId}`, state: { data: this.state.idList } }}>
                          <Button type="button" variant="info" size="sm">
                            Next
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}

                    {this.state.previous_property_id && this.state.idList.length === 0 && (
                      <Nav.Item>
                        <LinkContainer to={{ pathname: `/properties/${this.state.previous_property_id}`, state: { data: [] } }}>
                          <Button type="button" variant="info" size="sm">
                            Previous
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}
                    {this.state.next_property_id && this.state.idList.length === 0 && (
                      <Nav.Item>
                        <LinkContainer to={{ pathname: `/properties/${this.state.next_property_id}`, state: { data: [] } }}>
                          <Button type="button" variant="info" size="sm">
                            Next
                          </Button>
                        </LinkContainer>{" "}
                      </Nav.Item>
                    )}

                    {this.state.currentIdIndex !== null && this.state.idList.length > 0 && (
                      <Form.Group as={Row} controlId="currentIdIndex">
                        <Col className="zeroPadRight">
                          <Form.Control onChange={this.handleCurrentIdIndexChange} value={this.state.currentIdIndex + 1} as="input" type="text" min="0" className="pageCount" onBlur={this.handleGoToRecord} onKeyDown={this.handleEnterCurrentIdIndex} />
                        </Col>
                        <Col className="zeroPadLeft">
                          <h6>
                            <div className="topPad">of {this.state.idList.length} </div>
                          </h6>
                        </Col>
                      </Form.Group>
                    )}
                    {this.state.currentIdIndex !== null && this.state.idList.length > 0 && (
                      <NavDropdown title="Go To Cityscope Reference">
                        {this.state.idList.map((r) => (
                          <LinkContainer to={{ pathname: `/properties/${r}`, state: { data: this.state.idList } }}>
                            <NavDropdown.Item eventKey={r}>{r}</NavDropdown.Item>
                          </LinkContainer>
                        ))}
                      </NavDropdown>
                    )}
                  </Nav>
                </Col>
                <Col Col md={1} lg={1}>
                  {this.state.withholdings.length > 0 && (
                    <Button variant="danger" type="button" onClick={this.toggleWithholdingModal} size="sm">
                      On Hold
                    </Button>
                  )}
                </Col>
                <Col md={5} lg={5}>
                  <Nav className="justify-content-end ">
                    <Nav.Item>
                      <Button variant="primary" type="button" size="sm" onClick={this.togglePropertyAddModal}>
                        Bulk Add Properties
                      </Button>{" "}
                    </Nav.Item>
                    <Nav.Item>
                      <a target="_blank" href={`https://www.cityscopeonline.com.au/Logon.aspx?autolog=ThdvAU+ei+Y=&ref=${this.state.property_key.replace(".0", ".")}`}>
                        <Button size="sm" variant="primary" type="button">
                          View Live Data
                        </Button>
                      </a>{" "}
                    </Nav.Item>
                    <Nav.Item>
                      <a href={`/properties/${this.state.property_key}/previewtext`} target="_blank">
                        <Button variant="primary" size="sm" type="button">
                          Preview Text
                        </Button>
                      </a>{" "}
                    </Nav.Item>
                    <Nav.Item>
                      <Button variant="primary" type="button" onClick={this.handleHold} size="sm">
                        Hold Property
                      </Button>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Form.Row>

              <Form.Row id="propertytabs">
                <Col>
                  <Modal
                    show={this.state.showAlert}
                    onHide={(e) => {
                      this.setState({ showAlert: !this.state.showAlert });
                    }}
                    centered
                  >
                    <Modal.Header closeButton>
                      {" "}
                      <Modal.Title>Uh Oh!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {" "}
                      <Alert variant="danger">{this.state.errorMessage}</Alert>{" "}
                    </Modal.Body>
                  </Modal>

                  <Tabs defaultActiveKey={0} activeKey={this.state.tabKey} id="tabset" onSelect={this.onTabSelect}>
                    <Tab eventKey={15} title="Address Details">
                      <Card>
                        <Form.Row></Form.Row>

                        <Card.Body>
                          <Form.Row>
                            <Col sm={12} md={6} lg={3}>
                              <Card>
                                <Card.Header>Addresses</Card.Header>
                                <Card.Body>
                                  {!this.state.showCityscopeReference && (
                                    <Card>
                                      <Card.Body>
                                        <Button onClick={this.toggleAddressModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                                          Edit
                                        </Button>
                                        <AddressList filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.addresses} updateTableState={this.updateTableState} saveRecord={this.saveAddressesRecord} deleteRecord={this.deleteRecord} />
                                      </Card.Body>
                                    </Card>
                                  )}
                                  <Form.Group as={Row} controlId="suburb">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Suburb
                                    </Form.Label>
                                    <Col>
                                      <Select value={this.state.selectedSuburb} onChange={this.handleSuburbChange} options={this.state.suburbOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} isDisabled={this.state.head_record_property_id ? true : false} />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="state">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      State
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.state} as="input" type="text" readOnly />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="postcode">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Postcode
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.postcode} as="input" type="text" readOnly />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="frontages_text">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Frontages (Text)
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.frontages_text || ""} as="input" type="text" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                    </Col>
                                  </Form.Group>

                                  <Form.Group as={Row} controlId="zoning_text">
                                    <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                                      Zoning
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.zoning_text || ""} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} />
                                    </Col>
                                  </Form.Group>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col sm={12} md={6} lg={3}>
                              {true && (
                                <Card>
                                  <Card.Header>CoreLogic Equivalent Properties</Card.Header>
                                  <Card.Body>
                                    <Card>
                                      <Card.Body>
                                        <Button onClick={this.togglePropertyIntegrationsModal} size="sm" variant="secondary" type="button">
                                          Verify
                                        </Button>
                                        <RefreshButton onClick={this.updateIntegrations} onTimeout={this.getIntegrations} timeout={30000} size="sm" variant="secondary" type="button" style={{float: "right"}} />
                                        <PropertyIntegrationsList filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.integrations} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} acceptIntegration={this.acceptIntegration} rejectIntegration={this.rejectIntegration} ctx="cs" />
                                      </Card.Body>
                                    </Card>
                                  </Card.Body>
                                </Card>
                              )}
                              {true && (
                                <Card>
                                  <Card.Header>Parcels (Top 5 - click Edit to view all)</Card.Header>
                                  <Card.Body>
                                    <Col>
                                      <Button onClick={this.toggleTitleDetailsModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                                        Edit
                                      </Button>
                                      <TitleDetailsList filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.titleDetails} dataFetch={this.getTitleDetails} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} stateCode={this.state.state} />
                                      <br />
                                    </Col>
                                  </Card.Body>
                                </Card>
                              )}
                              {true && (
                                <Card>
                                  <Card.Header>Volume Folios (Top 5 - click Edit to view all)</Card.Header>
                                  <Card.Body>
                                    <Col>
                                      <Button onClick={this.toggleVolumeFoliosModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                                        Edit
                                      </Button>
                                      <VolumeFoliosList filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.volumeFolios} dataFetch={this.getVolumeFolios} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} />
                                    </Col>
                                  </Card.Body>
                                </Card>
                              )}
                            </Col>
                            <Col sm={12} md={6} lg={3}>
                              <Card>
                                <Card.Header>Title Details</Card.Header>
                                <Card.Body>
                                  <Form.Group as={Row} controlId="title_details">
                                    <Form.Label as={Col} className="text-right" column sm={3} md={3} lg={3}>
                                      Title Details
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.title_details} as="textarea" type="text" onBlur={this.handleBlur} rows="10" disabled={true} />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="title_details_postamble">
                                    <Form.Label as={Col} className="text-right" column sm={3} md={3} lg={3}>
                                      Title Details Postamble
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.title_details_postamble} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="title_notes">
                                    <Form.Label as={Col} className="text-right" column sm={3} md={3} lg={3}>
                                      Title Notes
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.title_notes} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                                    </Col>
                                  </Form.Group>
                                  <Form.Group as={Row} controlId="archived_title_details">
                                    <Form.Label as={Col} className="text-right" column sm={3} md={3} lg={3}>
                                      Archived Title Details
                                    </Form.Label>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.title_details_archive} as="textarea" type="text" onBlur={this.handleBlur} rows="5" disabled={true} />
                                    </Col>
                                  </Form.Group>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col sm={12} md={6} lg={3}>
                              <Card>
                                <Card.Header>Photos</Card.Header>
                                <Card.Body>
                                  {this.state.propertyPhotos.length === 0 && <span>No photos.</span>}
                                  {this.state.propertyPhotos.map((p) => (
                                    <div>
                                      <img src={p.url} style={{ maxWidth: "100%" }} />
                                      <span class="pl-1" style={{ display: "block" }}>
                                        <strong>Photo Last Modified:</strong>&nbsp;
                                        {new Moment(p.last_edited_date).local().format("DD-MM-YYYY")}
                                      </span>
                                    </div>
                                  ))}
                                </Card.Body>
                              </Card>
                            </Col>
                          </Form.Row>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={0} title="Property Details">
                      <Card>
                        <Card.Body>
                          <Form.Row>
                            {!this.state.showCityscopeReference && (
                              <Col sm={2} md={2} lg={2}>
                                <Button size="sm" type="button" variant="secondary" onClick={this.toggleCityscopeReference}>
                                  Renumber Property
                                </Button>{" "}
                                <Button size="sm" variant="secondary" type="button" onClick={this.handleDelete}>
                                  Delete Property
                                </Button>
                              </Col>
                            )}
                            <Col>
                              {this.state.head_record_property_id && (
                                <div>
                                  <font color="red">This property has a head record in a non-unit scope. Edit the property details in the non-unit scope.</font>
                                </div>
                              )}
                            </Col>
                          </Form.Row>
                          {this.state.showCityscopeReference && (
                            <Form.Row>
                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="cityscope">
                                <Form.Label className="text-right">Cityscope</Form.Label>

                                <Select value={this.state.selectedCityscope} onChange={this.handleCityscopeChange} options={this.state.cityscopeOptions} onInputChange={this.handleInputChange} />
                              </Form.Group>

                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="map_number">
                                <Form.Label className="text-right">Map No.</Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.map_number} as="input" type="text" />
                              </Form.Group>
                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="map_number_suffix">
                                <Form.Label className="text-right">Map No. Suffix</Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.map_number_suffix} as="input" type="text" />
                              </Form.Group>
                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="property_number">
                                <Form.Label className="text-right">Property No.</Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.property_number} as="input" type="text" />
                              </Form.Group>
                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="property_number_suffix">
                                <Form.Label className="text-right">Property No. Suffix</Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.property_number_suffix} as="input" type="text" />
                              </Form.Group>

                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="unit_number">
                                <Form.Label className="text-right">Unit No.</Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.unit_number} as="input" type="number" />
                              </Form.Group>

                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="unit_number_suffix">
                                <Form.Label className="text-right">Unit No. Suffix </Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.unit_number_suffix} as="input" type="text" />
                              </Form.Group>

                              <Form.Group as={Col} column sm={1} md={1} lg={1} controlId="unit_sort">
                                <Form.Label className="text-right">Unit Sort</Form.Label>

                                <Form.Control onChange={this.handleChange} value={this.state.unit_sort} as="input" type="text" />
                              </Form.Group>
                              <Col>
                                <Button variant="primary" onClick={this.handleRenumber} type="button">
                                  Save
                                </Button>{" "}
                                <Button variant="primary" type="button" onClick={this.cancelCityscopeReferenceChange}>
                                  Cancel
                                </Button>{" "}
                              </Col>
                            </Form.Row>
                          )}

                          {!this.state.showCityscopeReference && (
                            <Form.Row>
                              <Col sm={12} md={6} lg={3}>
                                <Card>
                                  <Card.Header>Description</Card.Header>
                                  {/* Description */}
                                  <Card.Body>
                                    <Form.Group as={Row} controlId="description">
                                      {/* <Form.Label className="text-right">Description</Form.Label> */}

                                      <Form.Control onChange={this.handleChange} value={this.state.description || ""} as="textarea" rows="25" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="description_postamble">
                                      <Form.Label className="text-right">Description Postamble</Form.Label>

                                      <Form.Control onChange={this.handleChange} value={this.state.description_postamble || ""} as="textarea" rows="2" onBlur={this.handleBlur} />
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="description_notes">
                                      <Form.Label className="text-right">Description Notes</Form.Label>

                                      <Form.Control onChange={this.handleChange} value={this.state.description_notes} as="textarea" rows="6" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                                    </Form.Group>
                                  </Card.Body>
                                </Card>
                              </Col>
                              <Col sm={12} md={6} lg={3}>
                                <Card>
                                  <Card.Header>Key Attributes</Card.Header>
                                  <Card.Body>
                                    <Form.Group as={Row} controlId="sub_divided_unit">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Sub-divided Unit
                                      </Form.Label>
                                      <Col>
                                        <Form.Check checked={this.state.sub_divided_unit} onChange={this.handleCheckBoxChange} label="" type="checkbox" name="sub_divided_unit" onBlur={this.handleBlur} disabled={this.state.disableSubDividedUnit} />
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="year_built">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Year Built
                                      </Form.Label>
                                      <Col>
                                        <Form.Control onChange={this.handleChange} value={this.state.year_built} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="year_refurb">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Year Refurbished
                                      </Form.Label>
                                      <Col>
                                        <Form.Control onChange={this.handleChange} value={this.state.year_refurb} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="bedrooms">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Bedrooms
                                      </Form.Label>
                                      <Col>
                                        <Form.Control onChange={this.handleChange} value={this.state.bedrooms} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="storeys">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Storeys{" "}
                                      </Form.Label>
                                      <Col>
                                        <Form.Control onChange={this.handleChange} value={this.state.storeys} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="parking_yes_no">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Parking
                                      </Form.Label>
                                      <Col>
                                        <Form.Check checked={this.state.parking_yes_no} onChange={this.handleCheckBoxChange} name="parking_yes_no" type="checkbox" label="" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="parking_num">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Parking No.
                                      </Form.Label>
                                      <Col>
                                        <Form.Control onChange={this.handleChange} value={this.state.parking_num} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="typical_floor_area">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Typical Floor Area
                                      </Form.Label>
                                      <Col>
                                        <InputGroup className="mb-3">
                                          <Form.Control onChange={this.handleChange} value={this.state.typical_floor_area} as="input" type="number" onBlur={this.handleBlur} disabled={!this.state.disableSubDividedUnit || this.state.head_record_property_id ? true : false} />
                                          <InputGroup.Append>
                                            <InputGroup.Text>m2</InputGroup.Text>
                                          </InputGroup.Append>
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="building_area">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Building Area
                                      </Form.Label>
                                      <Col>
                                        <InputGroup>
                                          <Form.Control onChange={this.handleChange} value={this.state.building_area} as="input" type="number" onBlur={this.handleBlur} />
                                          <InputGroup.Append>
                                            <InputGroup.Text>m2</InputGroup.Text>
                                          </InputGroup.Append>
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="nla_date">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Building Area Source Date
                                      </Form.Label>
                                      <Col>
                                        <div className="customDatePickerWidth">
                                          <DatePicker selected={this.state.nla_date != null ? new Date(this.state.nla_date) : ""} onChange={(e) => this.handleDateChange(e, "nla_date")} dateFormat="dd/MM/yyyy" onBlur={this.handleBlur} className="form-control internal" disabled={this.state.head_record_property_id ? true : false} />
                                        </div>
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="site_area">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Site Area
                                      </Form.Label>
                                      <Col>
                                        <InputGroup>
                                          <Form.Control onChange={this.handleChange} value={this.state.site_area} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                          <InputGroup.Append>
                                            <InputGroup.Text>m2</InputGroup.Text>
                                          </InputGroup.Append>
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="unit_area">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Unit Area
                                      </Form.Label>
                                      <Col>
                                        <InputGroup>
                                          <Form.Control onChange={this.handleChange} value={this.state.unit_area} as="input" type="number" onBlur={this.handleBlur} />
                                          <InputGroup.Append>
                                            <InputGroup.Text>m2</InputGroup.Text>
                                          </InputGroup.Append>
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="unit_level_number">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Unit Level
                                      </Form.Label>
                                      <Col>
                                        <Form.Control onChange={this.handleChange} value={this.state.unit_level_number} as="input" type="number" onBlur={this.handleBlur} disabled={this.state.disableSubDividedUnit} step="0.5" />
                                      </Col>
                                    </Form.Group>
                                  </Card.Body>
                                </Card>
                              </Col>

                              <Col sm={12} md={6} lg={3}>
                                <Form.Row>
                                  <Col>
                                    {!this.state.showCityscopeReference && (
                                      <Card>
                                        <Card.Header>Buildings</Card.Header>
                                        <Card.Body>
                                          <Button onClick={this.toggleBuildingNameModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                                            Edit
                                          </Button>
                                          <BuildingNameList filter={this.state.buildingNameFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.buildingNames} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} />
                                        </Card.Body>
                                      </Card>
                                    )}
                                    {!this.state.showCityscopeReference && (
                                      <Card>
                                        <Card.Header>Classification</Card.Header>
                                        <Card.Body>
                                          <Button onClick={this.togglePropertyClassificationModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                                            Edit
                                          </Button>
                                          <PropertyClassificationList filter={this.state.propertyClassificationFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.propertyClassifications} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} />
                                        </Card.Body>
                                      </Card>
                                    )}
                                    {!this.state.showCityscopeReference && (
                                      <Card>
                                        <Card.Header>Grade</Card.Header>
                                        <Card.Body>
                                          <Button onClick={this.toggleBuildingGradeModal} size="sm" variant="secondary" type="button" disabled={this.state.head_record_property_id ? true : false}>
                                            Edit
                                          </Button>
                                          <BuildingGradeList filter={this.state.buildingGradeFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.buildingGrades} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} />
                                        </Card.Body>
                                      </Card>
                                    )}
                                  </Col>
                                </Form.Row>
                              </Col>

                              <Col sm={12} md={6} lg={3}>
                                <Card>
                                  <Card.Header>Building Contacts</Card.Header>
                                  <Card.Body>
                                    <Form.Group as={Row} controlId="internet">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Website
                                      </Form.Label>
                                      <Col>
                                        <InputGroup>
                                          <InputGroup.Prepend>
                                            <InputGroup.Text>www.</InputGroup.Text>
                                          </InputGroup.Prepend>
                                          <Form.Control onChange={this.handleChange} value={this.state.internet} as="input" type="text" onBlur={this.handleBlur} pattern="www[.].*[.].*" placeholder="www.website.com" disabled={this.state.head_record_property_id ? true : false} />
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="email">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Email
                                      </Form.Label>
                                      <Col>
                                        <InputGroup>
                                          <InputGroup.Prepend>
                                            <InputGroup.Text>@</InputGroup.Text>
                                          </InputGroup.Prepend>
                                          <Form.Control onChange={this.handleChange} value={this.state.email} as="input" type="email" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="agentSearchString">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Agency Search
                                      </Form.Label>
                                      <Col>
                                        <InputGroup size="sm">
                                          <Form.Control onChange={this.handleChange} value={this.state.agentSearchString} onKeyDown={this.handleEnterOnAgentSearch} as="input" type="text" placeholder="Search entities" disabled={this.state.head_record_property_id ? true : false} />
                                          <InputGroup.Append>
                                            <Button onClick={this.handleAgentSearch} variant="outline-secondary" size="sm" type="button">
                                              Search
                                            </Button>
                                          </InputGroup.Append>
                                        </InputGroup>
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="Interstate">
                                      <Col column sm={6} md={6} lg={4}></Col>
                                      <Col>
                                        <Form.Check checked={this.state.agentInterstateFlag} onChange={this.handleCheckBoxChange} label="Search interstate" type="checkbox" name="agentInterstateFlag" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="selectedAgent">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Managing Agent
                                      </Form.Label>
                                      <Col>
                                        {this.state.showAgentDropDown && (
                                          <div>
                                            <Select isClearable value={this.state.selectedAgent} onChange={this.handleAgentChange} options={this.state.agentOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} menuIsOpen={this.state.agentMenuIsOpen} isDisabled={this.state.head_record_property_id ? true : false} />
                                            <Form.Control disabled value={this.state.managing_agent_email} readOnly as="input" type="text" />
                                          </div>
                                        )}
                                      </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} controlId="selectedAgentContact">
                                      <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                        Managing Agent Contact
                                      </Form.Label>
                                      <Col>{this.state.showAgentContactDropDown && <Select isClearable value={this.state.selectedAgentContact} onChange={this.handleAgentContactChange} options={this.state.agentContactOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} isDisabled={this.state.head_record_property_id ? true : false} />}</Col>
                                    </Form.Group>
                                    <Form.Row>
                                      <Col column sm={6} md={6} lg={4}></Col>
                                      <Col>
                                        <LinkContainer to={{ pathname: `../entities/new?cityscopereference=${this.state.property_key}`, state: { propertyidlist: this.state.idList } }}>
                                          <Button variant="info" size="sm" type="button">
                                            Add New Agent
                                          </Button>
                                        </LinkContainer>{" "}
                                        {this.state.entity_id_managing_agent && (
                                          <LinkContainer to={`../entities/${this.state.entity_id_managing_agent}?cityscopereference=${this.state.property_key}`}>
                                            <Button size="sm" variant="info" type="button">
                                              Edit Existing Agent
                                            </Button>
                                          </LinkContainer>
                                        )}
                                      </Col>
                                    </Form.Row>
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Form.Row>
                          )}
                        </Card.Body>
                      </Card>
                    </Tab>
                    {this.state.strataUnits.length > 0 && (
                      <Tab eventKey={12} title="Strata Units">
                        <Form.Row>
                          <Col>
                            <Nav className="justify-content-left">
                              <Nav.Item>
                                <div>
                                  <Button variant="primary" onClick={this.handleCopyBuildingNamesToStrata} type="button" disabled={this.state.buildingNames.length === 0}>
                                    Copy Building Names
                                  </Button>{" "}
                                </div>
                              </Nav.Item>

                              <Nav.Item>
                                <div>
                                  <Button variant="primary" onClick={this.handleCopyClassificationsToStrata} type="button" disabled={this.state.propertyClassifications.length === 0}>
                                    Copy Classifications
                                  </Button>{" "}
                                </div>
                              </Nav.Item>
                              <Nav.Item>
                                <div>
                                  <Button variant="primary" onClick={this.handleCopyAddressesToStrata} type="button" disabled={this.state.addresses.length === 0}>
                                    Copy Street Address
                                  </Button>{" "}
                                </div>
                              </Nav.Item>
                              <Nav.Item>
                                <div>
                                  <Button variant="primary" onClick={this.handleCopyPropertySuburb} type="button">
                                    Copy Suburb+State+PC
                                  </Button>{" "}
                                </div>
                              </Nav.Item>
                              <Nav.Item>
                                <div>
                                  <Button variant="primary" onClick={this.handleCopyOwnersToStrata} type="button" disabled={this.state.propertyOwners.length === 0}>
                                    Copy Owners
                                  </Button>{" "}
                                </div>
                              </Nav.Item>
                              <Nav.Item>
                                <div>
                                  <Button variant="primary" onClick={this.handleCopyParcelsToStrata} type="button" disabled={this.state.titleDetails.length === 0}>
                                    Copy Parcels
                                  </Button>{" "}
                                </div>
                              </Nav.Item>
                            </Nav>
                          </Col>
                        </Form.Row>
                        <Form.Row>
                          <Col>
                            <Card>
                              {/* <Card.Header >

                                                    Strata Units

                                                </Card.Header> */}

                              <Card.Body>
                                <Card>
                                  <Card.Body>
                                    <StrataUnitList user={this.props.user} isAuthenticated={this.props.isAuthenticated} data={this.state.strataUnits} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} controlType="table" propertyid={this.state.property_id} propertykey={this.state.property_key} />
                                  </Card.Body>
                                </Card>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Form.Row>
                      </Tab>
                    )}

                    {/* {!this.state.showCityscopeReference &&*/}

                    <Tab eventKey={1} title={"Tenants"}>
                      <Card>
                        {/* <Card.Header >

                                                     Tenants

                                                </Card.Header> */}

                        <Card.Body>
                          <Row>
                            <Form.Group as={Col} controlId="occupants_preamble">
                              <Form.Label>Occupants Preamble</Form.Label>

                              <Form.Control onChange={this.handleChange} value={this.state.occupants_preamble} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} />
                            </Form.Group>

                            <Form.Group as={Col} controlId="occupants_postamble">
                              <Form.Label>Occupants Postamble</Form.Label>

                              <Form.Control onChange={this.handleChange} value={this.state.occupants_postamble} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} />
                            </Form.Group>

                            <Form.Group as={Col} controlId="occupants_notes">
                              <Form.Label>Occupants Notes</Form.Label>

                              <Form.Control onChange={this.handleChange} value={this.state.occupants_notes} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                            </Form.Group>
                          </Row>

                          <Card>
                            <Card.Body>
                              <LeaseList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.leases} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} floorTypeOptions={this.state.floorTypeOptions} leaseClassificationOptions={this.props.leaseClassificationOptions} propertyid={this.state.property_id} propertykey={this.state.property_key} buildingNameOptions={this.state.buildingNames} controlType="table" idList={this.state.idList} />
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={2} title="For Lease">
                      <Card>
                        {/* <Card.Header >

                                                     For Lease ({this.state.leasingAgents.length})

                                                </Card.Header> */}

                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <LeasingAgentList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.leasingAgents} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} state={this.state.state} validateRelatedRecord={this.validateRelatedRecord} getAgentsLeasing={this.getAgentsLeasing} getLeasingAgentContacts={this.getLeasingAgentContacts} leasingAgentOptions={this.state.leasingAgentOptions} leasingAgentContactOptions={this.state.leasingAgentContactOptions} propertyid={this.state.property_id} propertykey={this.state.property_key} idList={this.state.idList} />
                            </Card.Body>
                          </Card>
                          <Card>
                            <Card.Body>
                              <Form.Row className="show-grid with-margin">
                                <Col>
                                  <Form.Group as={Row} controlId="leasing_notes">
                                    <Form.Label column sm={6} md={6} lg={4}>
                                      Leasing Notes.
                                    </Form.Label>
                                    <Form.Control onChange={this.handleChange} value={this.state.leasing_notes} as="textarea" type="text" rows="3" onBlur={this.handleBlur} bsPrefix="internal" />
                                  </Form.Group>
                                </Col>
                              </Form.Row>
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={3} title="Occ. Rates">
                      <Card>
                        <Card.Body>
                          <OccupancyRateList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.occupancyRates} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} filter={this.state.occupancyRateFilter} validateRelatedRecord={this.validateRelatedRecord} controlType="table" propertyid={this.state.property_id} />
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={4} title="Proposals">
                      <Card>
                        {/* <Card.Header >

                                                     Proposals ({this.state.propertyProposals.length})

                                                </Card.Header> */}

                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <Form.Row>
                                <Col>
                                  <PropertyProposalList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.propertyProposals} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} controlType="table" propertyid={this.state.property_id} propertykey={this.state.property_key} idList={this.state.idList} />
                                </Col>
                              </Form.Row>
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={5} title="Nabers">
                      <Card>
                        {/* <Card.Header >

                                                    Nabers ({this.state.nabers.length})

                                                </Card.Header> */}

                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <NaberList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.nabers} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} nabersRatingTypeOptions={this.state.nabersRatingTypeOptions} filter={this.state.naberFilter} validateRelatedRecord={this.validateRelatedRecord} nabersRatingValues={this.state.nabersRatingValues} />
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={6} title="Lifts">
                      <Card>
                        {/* <Card.Header >

                                                    Lift Operators ({this.state.liftOperators.length})

                                                </Card.Header>
                                                 */}
                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <LiftOperatorList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.liftOperators} updateTableState={this.updateTableState} saveRecord={this.saveRecord} controlType="table" deleteRecord={this.deleteRecord} liftOperatorOptions={this.props.liftOperatorOptions} filter={this.state.liftOperatorFilter} validateRelatedRecord={this.validateRelatedRecord} />
                              <Form.Group as={Row} controlId="lift_notes">
                                <Form.Label column sm={3} md={2} lg={2}>
                                  Lift Notes
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.lift_notes} as="textarea" rows="7" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                                </Col>
                              </Form.Group>
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={7} title="Hist. Listings">
                      <Card>
                        <Card.Header>Historical Listings</Card.Header>

                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <Form.Group as={Row} controlId="historical_listings">
                                <Form.Label column sm={6} md={6} lg={4}>
                                  Historical Listings
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.historical_listings} as="textarea" type="text" rows="2" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} />
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="historical_notes">
                                <Form.Label column sm={6} md={6} lg={4}>
                                  Historical Listing Notes
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.historical_notes} as="textarea" rows="2" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                                </Col>
                              </Form.Group>
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={8} title="Sales">
                      <Card>
                        {/* <Card.Header >Sales

                                                </Card.Header> */}

                        <Card.Body>
                          <Form.Row>
                            <Col column sm={6} md={6} lg={8}>
                              <Form.Group as={Row} controlId="title_details">
                                <Form.Label column sm={6} md={3} lg={2}>
                                  Title Details
                                </Form.Label>
                                <Col>
                                  <Row>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.title_details} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={true} />
                                    </Col>
                                  </Row>
                                </Col>
                              </Form.Group>
                            </Col>
                          </Form.Row>

                          <Form.Row>
                            <Col column sm={6} md={6} lg={8}>
                              <Form.Group as={Row} controlId="sales_text">
                                <Form.Label column sm={6} md={3} lg={2}>
                                  Sales History
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.sales_text} as="textarea" type="text" onBlur={this.handleBlur} rows="6" disabled={this.state.head_record_property_id ? true : false} />
                                </Col>
                              </Form.Group>

                              <Form.Group as={Row} controlId="sales_history_postamble">
                                <Form.Label column sm={6} md={3} lg={2}>
                                  Sales History Postamble
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.sales_history_postamble} as="textarea" type="text" onBlur={this.handleBlur} rows="1" />
                                </Col>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group as={Row} controlId="sales_notes">
                                <Form.Label column sm={6} md={3} lg={2}>
                                  Sales Notes
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.sales_notes} as="textarea" type="text" onBlur={this.handleBlur} rows="7" disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                                </Col>
                              </Form.Group>
                            </Col>
                          </Form.Row>

                          <Card>
                            <Card.Body>
                              <PropertySaleList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.propertySales} updateTableState={this.updateTableState} controlType="table" saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} idList={this.state.idList} validateRelatedRecord={this.validateRelatedRecord} propertyid={this.state.property_id} propertykey={this.state.property_key} primaryCategory={this.state.propertyClassifications.length > 0 ? this.state.propertyClassifications[0] : null} IsUnit={this.state.unit_number && (this.state.parking_yes_no || this.state.parking_num) && this.state.propertyClassifications.map((r) => r.classification).indexOf("Car Park") < 0 ? true : false} />
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={9} title="Ownership">
                      <Card>
                        {/* <Card.Header >

                                                    Ownership ({this.state.propertyOwners.length})

                                                </Card.Header> */}

                        <Card.Body>
                          <Form.Group as={Row} controlId="owner_preamble">
                            <Form.Label column sm={3} md={3} lg={1}>
                              Owner Preamble
                            </Form.Label>
                            <Col>
                              <Form.Control onChange={this.handleChange} value={this.state.owner_preamble} as="textarea" type="text" onBlur={this.handleBlur} rows="2" disabled={this.state.head_record_property_id ? true : false} />
                            </Col>
                          </Form.Group>

                          <Card>
                            <Card.Body>
                              <Form.Row>
                                <Col sm={4} md={4} lg={8}>
                                  {" "}
                                </Col>
                                <Col sm={4} md={4} lg={4}>
                                  <Form.Group as={Row} controlId="copyPropertyOwner">
                                    <Col>
                                      <Button variant="info" onClick={this.toggleOwnerSearchDialog} type="button">
                                        Search + Add Owners
                                      </Button>{" "}
                                    </Col>
                                    <Col>
                                      <Form.Label className="float-right">Copy Owners from:</Form.Label>
                                    </Col>
                                    <Col>
                                      <Form.Control onChange={this.handleChange} value={this.state.copyPropertyOwner} as="input" type="text" onBlur={this.handleBlur} placeholder="Cityscope ref" />
                                      <Form.Check checked={this.state.copyPropertyOwnerAndDeleteFlag} onChange={this.handleCheckBoxChange} name="copyPropertyOwnerAndDeleteFlag" label="Delete existing?" type="checkbox" onBlur={this.handleBlur} />
                                    </Col>
                                    <Col>
                                      <Button variant="info" onClick={this.handleCopyPropertyOwners} type="button">
                                        Copy
                                      </Button>
                                    </Col>
                                  </Form.Group>
                                </Col>
                              </Form.Row>
                              <Form.Row>
                                <Col>
                                  <PropertyOwnerList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.propertyOwners} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} idList={this.state.idList} controlType="table" validateRelatedRecord={this.validateRelatedRecord} propertyid={this.state.property_id} propertykey={this.state.property_key} />
                                </Col>
                              </Form.Row>
                            </Card.Body>
                          </Card>

                          <Form.Group as={Row} controlId="owner_postamble">
                            <Form.Label column sm={3} md={3} lg={1}>
                              Owner Postamble
                            </Form.Label>
                            <Col>
                              <Form.Control onChange={this.handleChange} value={this.state.owner_postamble} as="textarea" type="text" onBlur={this.handleBlur} rows="3" disabled={this.state.head_record_property_id ? true : false} />
                            </Col>
                          </Form.Group>
                          <Form.Group as={Row} controlId="lease_term">
                            <Form.Label column sm={3} md={3} lg={1}>
                              Lease Term
                            </Form.Label>
                            <Col>
                              <Form.Control onChange={this.handleChange} value={this.state.lease_term} as="textarea" type="text" onBlur={this.handleBlur} rows="3" disabled={this.state.head_record_property_id ? true : false} />
                            </Col>
                          </Form.Group>
                          <Form.Group as={Row} controlId="owner_notes">
                            <Form.Label column sm={6} md={6} lg={1}>
                              Owner Notes
                            </Form.Label>
                            <Col>
                              <Form.Control onChange={this.handleChange} value={this.state.owner_notes} as="textarea" type="text" rows="2" onBlur={this.handleBlur} disabled={this.state.head_record_property_id ? true : false} bsPrefix="internal" />
                            </Col>
                          </Form.Group>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={10} title={"Queries (" + this.state.activeQueries.length + ")"}>
                      <Card>
                        {/* <Card.Header >

                                                    Queries ({this.state.activeQueries.length})

                                                </Card.Header> */}
                        <Card.Body>
                          <Form.Row>
                            <Col sm={6} md={6} lg={4}>
                              <Form.Group as={Row} controlId="photo_required">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  Photo Required
                                </Form.Label>
                                <Col>
                                  <Form.Check checked={this.state.photo_required} onChange={this.handleCheckBoxChange} name="photo_required" label="" type="checkbox" onBlur={this.handleBlur} />
                                </Col>
                              </Form.Group>

                              <Form.Group as={Row} controlId="photo_why">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  New Photo Reason
                                </Form.Label>
                                <Col>
                                  <Form.Control onChange={this.handleChange} value={this.state.photo_why} as="textarea" type="text" onBlur={this.handleBlur} rows="2" />
                                </Col>
                              </Form.Group>
                            </Col>
                            <Col></Col>
                          </Form.Row>
                          <Card>
                            <Card.Body>
                              <QueryList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.queries} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} propertyId={this.props.match.params.id} validateRelatedRecord={this.validateRelatedRecord} />
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>
                    <Tab eventKey={11} title={"Sale Sheets (" + this.state.activePropertySaleSheets.length + ")"}>
                      <Card>
                        {/* <Card.Header >

                                                    Sale Sheets ({this.state.activePropertySaleSheets.length})

                                                </Card.Header> */}

                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <PropertySaleSheetList user={this.props.user} isAuthenticated={this.props.isAuthenticated} data={this.state.propertySaleSheets} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} controlType="table" propertyid={this.state.property_id} propertykey={this.state.property_key} idList={this.state.idList} />
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>

                    <Tab eventKey={13} title="Articles">
                      <Card>
                        {/* <Card.Header >

                                                    Articles ({this.state.propertyArticles.length})

                                                </Card.Header> */}

                        <Card.Body>
                          <Card>
                            <Card.Body>
                              <PropertyArticleList isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.propertyArticles} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} propertyid={this.state.property_id} propertykey={this.state.property_key} controlType="table" articleCategories={this.props.articleCategories} fileTypes={this.props.fileTypes} idList={this.state.idList} />
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>

                    <Tab eventKey={14} title="History">
                      <Card>
                        {/* <Card.Header >

                                                    Record History

                                                </Card.Header> */}

                        <Card.Body>
                          <Card style={{ width: "28rem" }}>
                            <Card.Body>
                              <Form.Group as={Row} controlId="created_date">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  Created Date
                                </Form.Label>
                                <Col>
                                  <Form.Control value={this.state.created_date != null ? Moment(this.state.created_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                                </Col>
                              </Form.Group>

                              <Form.Group as={Row} controlId="created_by">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  Created By
                                </Form.Label>
                                <Col>
                                  <Form.Control value={this.state.created_by} plaintext readOnly />
                                </Col>
                              </Form.Group>

                              <Form.Group as={Row} controlId="last_edited_date">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  Last Edited Date
                                </Form.Label>
                                <Col>
                                  <Form.Control value={this.state.last_edited_date != null ? Moment(this.state.last_edited_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                                </Col>
                              </Form.Group>

                              <Form.Group as={Row} controlId="last_edited_by">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  Last Edited By
                                </Form.Label>
                                <Col>
                                  <Form.Control value={this.state.last_edited_by} plaintext readOnly />
                                </Col>
                              </Form.Group>
                              <Form.Group as={Row} controlId="archived_date">
                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                  Archived Date
                                </Form.Label>
                                <Col>
                                  <DatePicker selected={this.state.archived_date != null ? new Date(this.state.archived_date) : null} onChange={(e) => this.handleDateChange(e, "archived_date")} onBlur={this.handleBlur} dateFormat="dd/MM/yyyy" className="form-control" isClearable={true} />
                                </Col>
                              </Form.Group>
                            </Card.Body>
                          </Card>
                        </Card.Body>
                      </Card>
                    </Tab>

                    {/* }*/}
                  </Tabs>
                </Col>
              </Form.Row>
            </Form>
          </div>
        )}
      </div>
    );
  }
}
